import {
    ClearOutlined,
    CloseOutlined,
    GridOnOutlined,
    InfoOutlined,
    PauseCircleOutlined,
    PictureAsPdfOutlined,
    PlayCircleOutlined,
    PrintOutlined,
    SearchOutlined,
    SendToMobileOutlined,
    SettingsOutlined,
    TimelineOutlined,
    VisibilityOutlined,
    DeviceHubOutlined,
    CheckCircleOutlineOutlined,
} from "@mui/icons-material";

import {
    MenuItem,
    Box,
    Button,
    Card,
    CardActions,
    CardMedia,
    FormControl,
    Grid,
    IconButton,
    InputAdornment,
    Paper,
    TextField,
    Toolbar,
    Typography,
    Menu,
    Autocomplete,
    FormControlLabel,
    Checkbox,
    Divider,
    Pagination,
    Tabs,
    Tab,
    Tooltip,
    Skeleton,
    Chip,
    Switch,
    Radio,
    useMediaQuery
} from "@mui/material";

import {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";

import {
    eventHandlerMessage,
    formattedSpeed,
    getApiErrorMessage,
    getFilteredList,
    setToastRefToOpen,
} from "../../../functions/functions";

import usePagination from "../../../utils/usePagination";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import { Toast } from "primereact/toast";

import findAllTravelsWithFiltersResponse from "../../../resources/Api/report/findAllTravelsWithFiltersResponse";
import { clearRouteCache } from "./components/SimpleTripRoute";
import AllTripsMapLayer, { clearApproxRouteCache } from "./components/AllTripsMapLayer";
import { FeatureCollection, Point } from "geojson";

import {
    TravelReportDataType,
    TripPositionType,
    CustomerListType,
    DepartmentSimpleType,
    DriverListType,
    ReportItems,
    ReportType,
    SecretarySimpleType,
    SelectedParametersType,
    UserType,
    VehicleGroupType,
    VehicleListType,
    VehicleWithPositionsType,
    PositionsDetailType,
} from "../../../types/types";

import findAllReportsListResponse from "../../../resources/Api/report/findAllReportsListResponse";

import Rmodal from "../../../components/Rmodal";
import PdfPreviewModal from "../../../components/PdfPreviewModal";
import dayjs, { Dayjs } from "dayjs";

import findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdListResponse from "../../../resources/Api/vehicle/findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdListResponse";

import {
    LocalizationProvider,
    MobileDateTimePicker,
} from "@mui/x-date-pickers";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import getReportWithFiltersResponse from "../../../resources/Api/report/getReportWithFiltersResponse";

import findAllGroupsByCustomerIdAndSecretaryIdAndDepartmentIdListResponse from "../../../resources/Api/group/findAllGroupsByCustomerIdAndSecretaryIdAndDepartmentIdListResponse";

import { MenuItem as MenuIt } from "primereact/menuitem";

import GPositionsMap from "../../../components/example/GPositionMap";

import generatePositionsMapByVehicle from "../../../resources/Api/report/generatePositionsMapByVehicle";
import Directions from "./components/Directions";
import Heatmap from "./components/HeatMap";
import gerenatePositionsHeatMapByVehicleResponse from "../../../resources/Api/report/gerenatePositionsHeatMapByVehicleResponse";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../atoms/atoms";
import findAllGroupsExportResponse from "../../../resources/Api/group/findAllGroupsExportResponse";
import findAllGeofencesExportResponse from "../../../resources/Api/geofence/findAllGeofencesExportResponse";
import findAllDriversExportResponse from "../../../resources/Api/driver/findAllDriversExportResponse";
import findAllVehiclesExportResponse from "../../../resources/Api/vehicle/findAllVVehiclesExportResponse";
import findAllUsersExportResponse from "../../../resources/Api/accesses/findAllUsersExportResponse";
import helpTicketFindAllExportResponse from "../../../resources/Api/tickets/helpTicketFindAllExportResponse";
import TabPanel from "../home/components/TabPanel";
import deviceFindAllExportResponse from "../../../resources/Api/device/deviceFindAllExportResponse";
import identifierFindAllExportResponse from "../../../resources/Api/identifier/identifierFindAllExportResponse";
import customerFindAllExportResponse from "../../../resources/Api/customer/customerFindAllExportResponse";
import commandFindAllExportResponse from "../../../resources/Api/command/commandFindAllExportResponse";
import { customerDefault, departmentDefault, MENUS_ITENS, PROFILE_ACESSES, secretaryDefault } from "../../../consts/consts";
import customerFindAllListResponse from "../../../resources/Api/customer/customerFindAllListResponse";
import findAllSecretariesByCustomerIdListResponse from "../../../resources/Api/secretary/findAllSecretariesByCustomerIdListResponse";
import findAllDepartmentsByCustomerIdAndSecretaryIdListResponse from "../../../resources/Api/department/findAllDepartmentsByCustomerIdAndSecretaryIdListResponse";
import driverFindAllListResponse from "../../../resources/Api/driver/driverFindAllListResponse";
import findAllPlacesWithIqLocation from "../../../resources/Api/location/findAllPlacesWithIqLocation";
import LiveRoutesTracker from "./components/LiveRoutesTracker";
import customerDriverIdentifierExportResponse from "../../../resources/Api/customer/customerDriverIdentifierExportResponse";
import { getReportDateRangeMillis, getReportTimezone } from "../../../utils/reportDateRange";
import interestPointFindAllExportResponse from "../../../resources/Api/interestPoint/interestPointFindAllExportResponse";
import interestPointNearVehicleExportResponse from "../../../resources/Api/interestPoint/interestPointNearVehicleExportResponse";
import RoutesReportTab from "../RoutesReportTab";

// Na branch eram 31 e 32, ids que na main já são de relatórios operacionais.
const INTEREST_POINTS_REPORT_ID = 35;
const INTEREST_POINTS_NEAR_VEHICLE_REPORT_ID = 36;

const reportFilterFieldSx = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
        minHeight: 56,
        borderRadius: 2,
        backgroundColor: "#ffff",
        transition: "box-shadow 200ms ease, border-color 200ms ease",
        "& fieldset": { borderColor: "rgba(0, 63, 74, 0.24)" },
        "&:hover fieldset": { borderColor: "#006C77" },
        "&.Mui-focused": { boxShadow: "0 0 0 3px rgba(0, 183, 0, 0.12)" },
        "&.Mui-focused fieldset": { borderColor: "#00B700" },
        "&.Mui-disabled": { backgroundColor: "rgba(0, 63, 74, 0.04)" },
    },
    "& .MuiInputLabel-root": { fontFamily: "Prometo" },
};

const DEVICE_HISTORY_REPORT_IDS = [4, 6, 9];

export type EarthquakeProps = {
    id: string;
    mag: number;
    time: number;
    felt: number | null;
    tsunami: 0 | 1;
};

export type EarthquakesGeojson = FeatureCollection<Point, EarthquakeProps>;

const geojson: FeatureCollection<Point, EarthquakeProps> = {
    type: "FeatureCollection",
    features: [
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-15.5986686, -56.0991301],
            },
            properties: {
                id: "quake1",
                mag: 5.2,
                time: 1716364800000,
                felt: 150,
                tsunami: 0,
            },
        },
    ],
};

const safeNum = (val: any, fallback = 0): number => {
    if (typeof val === 'string') {
        val = val.replace(',', '.');
    }
    const n = Number(val);
    return isNaN(n) ? fallback : n;
};

const parseDate = (dateStr: any) => {
    if (!dateStr) return null;
    // Se a data vier no formato DD/MM/YYYY HH:mm:ss, o dayjs pode precisar de ajuda em alguns browsers
    if (typeof dateStr === 'string' && dateStr.includes('/') && dateStr.indexOf('/') < 5) {
        const [date, time] = dateStr.split(' ');
        const [day, month, year] = date.split('/');
        return dayjs(`${year}-${month}-${day}T${time || '00:00:00'}`);
    }
    return dayjs(dateStr);
};

const formatDuration = (seconds: number) => {
    const s = safeNum(seconds);
    const hrs = Math.floor(s / 3600);
    const mins = Math.floor((s % 3600) / 60);
    const secs = Math.floor(s % 60);
    return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

const constructGeoJson = (
    data: Array<{ lat: number; lng: number; mag: number }>
): FeatureCollection<Point, EarthquakeProps> => {
    return {
        type: "FeatureCollection",
        features: data.map((item, index) => ({
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [item.lng, item.lat], // Ordem correta: longitude primeiro
            },
            properties: {
                id: `local_${index}`,
                mag: item.mag,
                time: Date.now(),
                felt: 200,
                tsunami: 1,
            },
        })),
    };
};

const items: MenuIt[] = [
    {
        label: "PDF",
        icon: <PictureAsPdfOutlined />,
    },
    {
        label: "Excel",
        icon: <GridOnOutlined />,
    },
    {
        label: "Excel simples",
        icon: <GridOnOutlined />,
    },
];

const reportCountManagerItens: ReportItems[] = [
    {
        id: 23,
        name: "Total de dispositivos",
        description:
            "Relatório visual que mostra o total de dispositivos.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 24,
        name: "Total de identificadores",
        description: "Relatório visual que mostra o total de identficadores.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 25,
        name: "Total de clientes",
        description: "Relatório visual que mostra o total de clientes.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 26,
        name: "Total de comandos",
        description: "Relatório visual que mostra o total de comandos criados.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 27,
        name: "Total de acessos",
        description: "Relatório visual que mostra o total de acessos administrativos.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 28,
        name: "Total de atendimentos",
        description: "Relatório visual que mostra o total de atendimentos respondidos.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
];

const reportTechnicianItens: ReportItems[] = [
    ...reportCountManagerItens,
    {
        id: 32,
        name: "Parâmetros do veículo",
        description: "Relatório dos parâmetros operacionais configurados para um veículo.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
];

const reportCountItens: ReportItems[] = [
    {
        id: 17,
        name: "Total de grupos",
        description:
            "Relatório visual que mostra o total de grupos.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 18,
        name: "Total de cercas virtuais",
        description: "Relatório visual que mostra o total de cercas virtuais.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 19,
        name: "Total de motoristas",
        description: "Relatório visual que mostra o total de motoristas.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 20,
        name: "Total de veículos",
        description: "Relatório visual que mostra o total de veículos.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 21,
        name: "Total de sub-acessos",
        description: "Relatório visual que mostra o total de sub-acessos do cliente.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 22,
        name: "Total de atendimentos solicitados",
        description: "Relatório visual que mostra o total de atendimentos solicitados.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
];

const reportAnaliticItens: ReportItems[] = [
    {
        id: 11,
        name: "Tempo ligado x Tempo parado",
        description: "Relatório visual que mostra o trajeto de um veículo em um dado período.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 12,
        name: "Velocidade média por período",
        description: "Relatório visual dos lugares mais percorridos.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 13,
        name: "Velocidade máxima por período",
        description: "Relatório visual que mostra a melhor rota entre dois pontos.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 14,
        name: "Velocidade máxima x velocidade permitida",
        description: "Relatório visual que mostra a melhor rota entre dois pontos.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 15,
        name: "Odômetro consolidado por período",
        description: "Relatório consolidado com odômetro inicial, final e quilometragem percorrida por veículo.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 16,
        name: "Motorista x utilização do veículo",
        description: "Relatório visual que mostra a melhor rota entre dois pontos.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 29,
        name: "Uso simples por motorista",
        description: "Relatório visual que mostra os veículos utilizados pelos motoristas de forma simplificada.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 30,
        name: "Motorista x identificadores",
        description: "Relatório visual que mostra o total de motositas e seu vinculo com identificadores.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 34,
        name: "Jornada de trabalho",
        description: "Lista os condutores com a carga horária, intervalo e dias de folga configurados.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: INTEREST_POINTS_REPORT_ID,
        name: "Total de pontos de interesse",
        description: "Relatório que lista todos os pontos de interesse do cliente com nome, descrição, endereço e status.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: INTEREST_POINTS_NEAR_VEHICLE_REPORT_ID,
        name: "Pontos de interesse próximos do veículo",
        description: "Relatório que mostra os pontos de interesse mais próximos do veículo selecionado, com opção de exportação.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
];

const reportMapItens: ReportItems[] = [
    {
        id: 1,
        name: "Trajeto por veículo",
        description:
            "Relatório visual que mostra o trajeto de um veículo em um dado período.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
        // replay do trajeto do veículo em determinado período
    },
    {
        id: 2,
        name: "Mapa de calor",
        description: "Relatório visual dos lugares mais percorridos.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
        // lugares mais visitados e lugares com perca de conexão
    },
    {
        id: 3,
        name: "Melhor rota",
        description: "Relatório visual que mostra a melhor rota entre dois pontos.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
        // traçar melhor rota entre dois pontos
    },
    {
        id: 4,
        name: "Resumo de viagens",
        description: "Relatório visual que mostra dário de bordo de viagens e o mapa.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
    {
        id: 5,
        name: "Rotas previstas x rotas realizadas",
        description: "Compare as rotas previstas com os trajetos realizados por veículo e período.",
        icon: <PictureAsPdfOutlined />,
        activated: true,
    },
];

const INITIAL_ADDRESSES = [{
    query: "",
    predictionResults: [],
    localLat: 0,
    localLng: 0,
}, {
    query: "",
    predictionResults: [],
    localLat: 0,
    localLng: 0,
}];

const MAX_STOPS = 10;
const VEHICLE_OPERATIONAL_REPORT_IDS = [31, 32, 33];

/**
 * ReportPage - Component that renders a page to list, configure and print reports
 * @component
 */
const ReportPage = ({ isHiddenMenu, allowCalculatedRoutes = true }: { isHiddenMenu: boolean; allowCalculatedRoutes?: boolean }) => {
    const isMobile = useMediaQuery("(max-width:650px)");
    // atoms
    const getCurrentUser = useRecoilValue<UserType>(userAtom);
    const isTechnician = getCurrentUser.accessProfile.id === Number(PROFILE_ACESSES.TECHNICIAN);
    const canViewPlannedRoutes = allowCalculatedRoutes && getCurrentUser.permissions.some(
        (permission) => permission.optionItem.id === Number(MENUS_ITENS.ROUTES) && permission.canView
    );

    // functionalities states
    const [isOnline, setIsOnline] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);
    const [validationText, setTextValidation] = useState<string>("");
    const [isFieldsValid, setFieldsIsValid] = useState<boolean>(true);
    const [statusMessage, setStatusMessage] = useState<
        "warn" | "success" | "info" | "error" | undefined
    >("warn");
    const [isToastVisible, setIsToastVisible] = useState(false);

    const [query, setQuery] = useState<string>("");
    const [filteredList, setFilteredList] = useState<Array<ReportItems>>([]);
    const [isOpenDetails, setIsOpenDetails] = useState<boolean>(false);
    const [isOpenReportMap, setIsOpenReportMap] = useState<boolean>(false);
    const [isOpenRoutesReport, setIsOpenRoutesReport] = useState<boolean>(false);
    const [isRoutesReportExpanded, setIsRoutesReportExpanded] = useState<boolean>(false);
    const [page, setPage] = useState(1);

    // states
    const [customersList, setCustomersList] = useState<Array<CustomerListType>>([]);
    const [secretariesList, setSecretariesList] = useState<Array<SecretarySimpleType>>([]);
    const [departmentsList, setDepartmentsList] = useState<Array<DepartmentSimpleType>>([]);

    const [customer, setCustomer] = useState<CustomerListType>(customerDefault);
    const [secretary, setSecretary] = useState<SecretarySimpleType>(secretaryDefault);
    const [department, setDepartment] = useState<DepartmentSimpleType>(departmentDefault);

    const [reportLists, setReportList] = useState<Array<ReportItems>>([]);
    const [selectedReport, setSelectedReport] = useState<ReportItems>({
        id: -1,
        name: "",
        description: "",
        icon: <></>,
        activated: true,
    });

    const [isViewingAll, setIsViewingAll] = useState<boolean>(false);
    const [onlyActives, setOnlyActives] = useState<boolean>(true);
    const [onlyInactives, setOnlyInactives] = useState<boolean>(false);

    const [startDate, setStartDate] = useState<Dayjs | null>(null);
    const [endDate, setEndDate] = useState<Dayjs | null>(null);
    const [repeatHeader, setRepeatHeader] = useState<boolean>(false);

    const [groupsList, setGroupsList] = useState<Array<VehicleGroupType>>([]);
    const [vehicleList, setVehicleList] = useState<Array<VehicleListType>>([]);
    const [driversList, setDriversList] = useState<Array<DriverListType>>([]);

    const [selectedDrivers, setSelectedDrivers] = useState<Array<string>>([]);
    const [selectedGroupsList, setSelectedGroupList] = useState<Array<string>>([]);
    const [groupVehicles, setGroupVehicles] = useState<Array<string>>([]);
    const [nearVehicleSelected, setNearVehicleSelected] = useState<VehicleListType | null>(null);
    const [maxDistanceKm, setMaxDistanceKm] = useState<string>("");

    const [reportMapData, setReportMapData] = useState<VehicleWithPositionsType>({} as any);
    const [reportHeatMapData, setReportHeatMapData] = useState<any>({});

    const [report, setReport] = useState<ArrayBuffer>(new ArrayBuffer(0));
    const [exportType, setExportType] = useState<string>("");
    const [reportType, setReportType] = useState<string>("common");
    const [open, setOpen] = useState<boolean>(false);

    const [showPaths, setShowPaths] = useState(true);
    const [cameraTracking, setCameraTracking] = useState(true);
    const [playTracking, setPlayTracking] = useState(true);

    const [reportTravelData, setReportTravelData] = useState<Array<TravelReportDataType>>([]);
    const [selectedTrip, setSelectedTrip] = useState<TravelReportDataType | null>(null);
    const [approxTrip, setApproxTrip] = useState<TravelReportDataType | null>(null);

    const [uppertTabValue, setUpperTabValue] = useState(4);
    const [tabValue, setTabValue] = useState(0);

    // Diário de bordo - aba de histórico de dispositivos
    const [logbookTabValue, setLogbookTabValue] = useState<number>(0);
    const [showActiveVehicles, setShowActiveVehicles] = useState<boolean>(true);
    const [selectedHistoryVehicle, setSelectedHistoryVehicle] = useState<VehicleListType | null>(null);
    const [selectedHistoryDevice, setSelectedHistoryDevice] = useState<any>(null);
    const [deviceHistorySearch, setDeviceHistorySearch] = useState<string>("");

    const hasDeviceHistoryFilter = useMemo(() => {
        const reportName = selectedReport.name?.toLowerCase() ?? "";

        return DEVICE_HISTORY_REPORT_IDS.includes(selectedReport.id)
            || reportName.includes("bordo")
            || reportName.includes("percurso");
    }, [selectedReport.id, selectedReport.name]);

    const isDeviceHistoryMode = hasDeviceHistoryFilter
        && logbookTabValue === 1
        && getCurrentUser.accessProfile.id !== Number(PROFILE_ACESSES.DRIVER);

    const [typingTimer, setTypingTimer] = useState<any>(0);

    // Múltiplas paradas - Melhor rota
    const [addresses, setAddresses] = useState<Array<{ query: string, predictionResults: Array<any>, localLat: number, localLng: number }>>([...INITIAL_ADDRESSES]);
    const [addressLoadingMap, setAddressLoadingMap] = useState<Record<number, boolean>>({});

    const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");
    const [pdfFileName, setPdfFileName] = useState("");

    // refs
    const toastModalRef = useRef<Toast>(null);
    const toastRef = useRef<Toast>(null);
    const mapRef = useRef<any>(null);
    const anchorRef = useRef<HTMLButtonElement | null>(null);

    // cookies
    const [cookies, _] = useCookies(["selectedParameters", "token"]);

    // hooks and consts
    // const location = useLocation();
    const currentParameters: SelectedParametersType = useMemo(() => cookies.selectedParameters, [cookies.selectedParameters]);
    const reportTimezone = useMemo(
        () => getReportTimezone({
            isManager: getCurrentUser.configs.isManager,
            authenticatedCustomerUtcZone: getCurrentUser.configs.customerSettings?.utcZone,
        }),
        [
            getCurrentUser.configs.isManager,
            getCurrentUser.configs.customerSettings?.utcZone,
        ],
    );
    const defaultReportStartDate = useMemo(
        () => dayjs().tz(reportTimezone).startOf("day"),
        [reportTimezone],
    );
    const defaultReportEndDate = useMemo(
        () => dayjs().tz(reportTimezone).endOf("day"),
        [reportTimezone],
    );
    const count = Math.ceil(filteredList.length / 8);

    const dataPage = usePagination<ReportItems>({
        data: filteredList,
        itemsPerPage: 8,
    });

    const positions = useMemo(() => {
        return addresses
            .filter(a => a.localLat && a.localLng)
            .map(a => ({
                lat: a.localLat,
                lng: a.localLng
            }));
    }, [addresses]);

    const origin = useMemo(() => {
        const address = addresses[0];
        return address?.localLat && address?.localLng ? `${address.localLat},${address.localLng}` : "";
    }, [addresses]);

    const waypoints = useMemo(() => {
        return addresses
            .slice(1, -1)
            .filter(a => a.localLat && a.localLng)
            .map(a => `${a.localLat},${a.localLng}`)
            .join("|");
    }, [addresses]);

    const destination = useMemo(() => {
        const address = addresses[addresses.length - 1];
        return address?.localLat && address?.localLng ? `${address.localLat},${address.localLng}` : "";
    }, [addresses]);

    const handleClose = useCallback(() => {
        setLoading(false);
        setStatusMessage("warn");
        setIsToastVisible(false);
        setTextValidation("");
        setIsOpenDetails(false);
        setSelectedReport({
            id: -1,
            name: "",
            description: "",
            icon: <></>,
            activated: true,
        });
        setIsOpenReportMap(false);
        setReportMapData({} as any);
        setGroupVehicles([]);
        setNearVehicleSelected(null);
        setMaxDistanceKm("");
        setSelectedGroupList([]);
        setStartDate(null);
        setEndDate(null);
        setIsViewingAll(false);
        setCustomer(customerDefault);
        setSecretary(secretaryDefault);
        setDepartment(departmentDefault);
        setSelectedTrip(null);
        setApproxTrip(null);
        setReportTravelData([]);
        setSelectedDrivers([]);
        setAddresses([...INITIAL_ADDRESSES]);
        setTypingTimer(0);
        clearApproxRouteCache();
        clearRouteCache();
        setLogbookTabValue(0);
        setShowActiveVehicles(true);
        setSelectedHistoryVehicle(null);
        setSelectedHistoryDevice(null);
        setDeviceHistorySearch("");
    }, []);

    useEffect(() => {
        const ref = isOpenDetails ? toastModalRef : toastRef;
        if (validationText && !isFieldsValid && !isToastVisible) {
            setToastRefToOpen(
                ref,
                validationText,
                "Atenção!",
                statusMessage,
                undefined,
                3000,
                false
            );
        }
    }, [
        isOpenDetails,
        validationText,
        isFieldsValid,
        statusMessage,
        isToastVisible,
    ]);

    const updateAddress = useCallback((index: number, patch: Partial<{
        query: string;
        predictionResults: Array<any>;
        localLat: number;
        localLng: number;
    }>) => {
        setAddresses(prev => {
            const newAddresses = [...prev];
            newAddresses[index] = { ...newAddresses[index], ...patch };
            return newAddresses;
        });
    }, []);

    const addStop = useCallback(() => {
        setAddresses(prev => {
            if (prev.length >= MAX_STOPS) return prev;
            const newStop = { query: "", predictionResults: [], localLat: 0, localLng: 0 };
            const newAddresses = [...prev];
            newAddresses.splice(newAddresses.length - 1, 0, newStop);
            return newAddresses;
        });
    }, []);

    const removeStop = useCallback((index: number) => {
        setAddresses(prev => {
            if (prev.length <= 2 || index === 0 || index === prev.length - 1) return prev;
            return prev.filter((_, i) => i !== index);
        });
    }, []);

    const getPlacesPredictions = useCallback(async (addressIndex: number, query: string) => {
        setAddressLoadingMap(prev => ({ ...prev, [addressIndex]: true }));
        try {
            const response = await findAllPlacesWithIqLocation(query);
            updateAddress(addressIndex, { predictionResults: response.data });
        } catch (error) {
            console.log(error);
            updateAddress(addressIndex, { predictionResults: [] });
        } finally {
            setAddressLoadingMap(prev => ({ ...prev, [addressIndex]: false }));
        }
    }, [updateAddress]);

    const handleAddressInputChange = useCallback((index: number) => (_: any, newInputValue: string) => {
        updateAddress(index, { query: newInputValue });
        clearTimeout(typingTimer);
        setTypingTimer(setTimeout(() => {
            if (newInputValue) getPlacesPredictions(index, newInputValue);
        }, 1000));
    }, [getPlacesPredictions, typingTimer, updateAddress]);

    const handleAddressSelect = useCallback((index: number) => (_: any, value: string | null) => {
        const selected = addresses[index]?.predictionResults.find((it: any) => it.display_name === value);
        if (selected) {
            updateAddress(index, {
                localLat: Number(selected.lat),
                localLng: Number(selected.lon),
                query: value ?? "",
            });
        }
    }, [addresses, updateAddress]);

    const getCustomersList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        try {
            const response = await customerFindAllListResponse(token, currentParameters.customer.id);
            setCustomersList(response.data);
        } catch (error) {
            console.log(error);
            setCustomersList([]);
        }
    }, [cookies.token, currentParameters]);

    useEffect(() => {
        if (getCurrentUser.configs.isManager && (uppertTabValue === 5)) {
            getCustomersList();
        }
    }, [getCustomersList, getCurrentUser.configs.isManager, uppertTabValue]);

    const getSecretariesList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const customerId = customer.id;

        try {
            const response = await findAllSecretariesByCustomerIdListResponse(
                token,
                customerId
            );
            setSecretariesList(response.data);
        } catch (error) {
            console.log(error);
            setSecretariesList([]);
        }
    }, [cookies.token, customer?.id]);

    useEffect(() => {
        if (customer?.name) {
            getSecretariesList();
        }
    }, [getSecretariesList, customer?.name]);

    const getDepartmentsList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const customerId = customer.id;
        const secretaryId = secretary.id;

        try {
            const response =
                await findAllDepartmentsByCustomerIdAndSecretaryIdListResponse(
                    token,
                    customerId,
                    secretaryId
                );
            setDepartmentsList(response.data);
        } catch (error) {
            console.log(error);
            setDepartmentsList([]);
        }
    }, [cookies.token, customer?.id, secretary?.id]);

    useEffect(() => {
        if (secretary?.name) {
            getDepartmentsList();
        }
    }, [getDepartmentsList, secretary?.name]);

    const getAllGroupsList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType = cookies.selectedParameters;

        const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer.id : customer.id;
        const departmentId = !getCurrentUser.configs.isManager ? currentParameters?.department.id : department.id;

        setLoading(true);
        try {
            const { data } =
                await findAllGroupsByCustomerIdAndSecretaryIdAndDepartmentIdListResponse(
                    token,
                    customerId,
                    currentParameters.userId,
                    departmentId,
                    "activated",
                    currentParameters.isViewingAll
                );
            if (data.length > 0) {
                setGroupsList(data);
            }
        } catch (error: any) {
            console.log(error);
            setGroupsList([]);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        }
    }, [cookies.selectedParameters, cookies.token, customer.id, department.id, getCurrentUser.configs.isManager
    ]);

    useEffect(() => {
        if (
            (selectedReport.id === 2 || selectedReport.id === 5) &&
            reportType === "common"
        ) {
            getAllGroupsList();
        }
    }, [getAllGroupsList, selectedReport.id, reportType]);

    const getAllVehicles = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType = cookies.selectedParameters;

        const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer.id : customer.id;
        const departmentId = !getCurrentUser.configs.isManager ? currentParameters?.department.id : department.id;

        setLoading(true);
        try {
            const { data } =
                await findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdListResponse(
                    token,
                    customerId,
                    departmentId,
                    currentParameters?.isViewingAll,
                    showActiveVehicles ? "activated" : "deactivated"
                );
            setVehicleList(data);
        } catch (error: any) {
            console.log(error);
            setVehicleList([]);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        }
    }, [cookies.selectedParameters, cookies.token, customer.id, department.id, getCurrentUser.configs.isManager, showActiveVehicles]);

    useEffect(() => {
        getAllVehicles();
    }, [getAllVehicles]);

    const getAllDrivers = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const currentParameters: SelectedParametersType = cookies.selectedParameters;

        const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer.id : customer.id;
        const departmentId = !getCurrentUser.configs.isManager ? currentParameters?.department.id : department.id;

        setLoading(true);
        try {
            const { data } =
                await driverFindAllListResponse(
                    token,
                    customerId,
                    departmentId,
                    currentParameters?.isViewingAll
                );
            setDriversList(data);
        } catch (error: any) {
            console.log(error);
            setDriversList([]);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        }
    }, [cookies.selectedParameters, cookies.token, customer.id, department.id, getCurrentUser.configs.isManager]);

    useEffect(() => {
        getAllDrivers();
    }, [getAllDrivers]);

    const getAllReportList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        setLoading(true);
        try {
            const { data } = await findAllReportsListResponse(token);
            setTabValue(0);
            const reportsData = data.filter((rep: any) => rep.id !== 1).filter((item: any) => { if (getCurrentUser.accessProfile.id === Number(PROFILE_ACESSES.DRIVER)) { return [6, 8, 9].includes(item.id) } else { return item } })
            setReportList(reportsData);
        } catch (error: any) {
            console.log(error);
            setReportList([]);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        }
    }, [cookies.token, getCurrentUser.accessProfile.id]);

    const getReport = useCallback(
        async (type: string) => {
            setLoading(true);
            let dataBuffer = new ArrayBuffer(0);
            const token: string = cookies.token || sessionStorage.getItem("token");
            const currentParameters: SelectedParametersType = cookies.selectedParameters;
            const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer.id : customer.id;
            const departmentId = !getCurrentUser.configs.isManager ? currentParameters?.department.id : department.id;
            const reportDateRange = getReportDateRangeMillis({
                startDate,
                endDate,
                isManager: getCurrentUser.configs.isManager,
                authenticatedCustomerUtcZone:
                    getCurrentUser.configs.customerSettings?.utcZone,
            });

            const filters: ReportType = {
                name: selectedReport.name,
                reportId: selectedReport.id,
                ...reportDateRange,
                repeatHeader,
                vehicles: groupVehicles.length > 0 ? groupVehicles.map((car) => Number(car)) : [selectedHistoryVehicle?.id!!],
                groups: selectedGroupsList.map((grp) => Number(grp)),
                drivers: driversList.filter((it) => it.driverIdentifier === selectedDrivers[0]).flatMap((a) => [a.driverCode1, a.driverCode2, a.driverCode3, a.driverIdentifier]),
                customerId: customerId,
                deviceId: selectedHistoryDevice?.id ?? null,
                departmentId: departmentId,
                secretaryId: secretary?.id ?? null,
            };

            let reportType = type;
            let isSimpleType = false;

            if (reportType.includes("simples")) {
                reportType = reportType.split(" ")[0];
                isSimpleType = true;
            }

            // simpleXlsxExport = false

            const isVAll = getCurrentUser.configs.isManager ? isViewingAll : currentParameters.isViewingAll;
            const status = onlyActives
                ? "activated"
                : onlyInactives
                    ? "deactivated"
                    : "activated";
            try {
                if (selectedReport.id >= 17 && selectedReport.id <= 28 || selectedReport.id === 30 || selectedReport.id === INTEREST_POINTS_REPORT_ID || selectedReport.id === INTEREST_POINTS_NEAR_VEHICLE_REPORT_ID) {
                    var reportCount = new ArrayBuffer(0);
                    switch (selectedReport.id) {
                        case 17:
                            const { data: a } = await findAllGroupsExportResponse(token, customerId, departmentId, status, reportType, isVAll, isSimpleType);
                            reportCount = a;
                            break;
                        case 18:
                            const { data: b } = await findAllGeofencesExportResponse(token, customerId, departmentId, status, reportType, isVAll, isSimpleType);
                            reportCount = b;
                            break;
                        case 19:
                            const { data: c } = await findAllDriversExportResponse(token, customerId, departmentId, status, reportType, isVAll, isSimpleType);
                            reportCount = c;
                            break;
                        case 20:
                            const { data: d } = await findAllVehiclesExportResponse(token, customerId, departmentId, status, reportType, isVAll, isSimpleType);
                            reportCount = d;
                            break;
                        case 21:
                            const { data: e } = await findAllUsersExportResponse(token, customerId, status, reportType, "customer", isSimpleType);
                            reportCount = e;
                            break;
                        case 22:
                            const { data: f } = await helpTicketFindAllExportResponse(token, status, reportType, customerId, departmentId, isVAll, isSimpleType);
                            reportCount = f;
                            break;
                        case 23:
                            const { data: g } = await deviceFindAllExportResponse(token, currentParameters.customer.id, status, reportType, isSimpleType);
                            reportCount = g;
                            break;
                        case 24:
                            const { data: h } = await identifierFindAllExportResponse(token, currentParameters.customer.id, status, reportType, isSimpleType);
                            reportCount = h;
                            break;
                        case 25:
                            const { data: i } = await customerFindAllExportResponse(token, status, currentParameters.customer.id, reportType, isSimpleType);
                            reportCount = i;
                            break;
                        case 26:
                            const { data: j } = await commandFindAllExportResponse(token, currentParameters.customer.id, status, reportType, isSimpleType);
                            reportCount = j;
                            break;
                        case 27:
                            const { data: k } = await findAllUsersExportResponse(token, currentParameters.customer.id, status, reportType, "manager", isSimpleType);
                            reportCount = k;
                            break;
                        case 28:
                            const { data: l } = await helpTicketFindAllExportResponse(token, status, reportType, currentParameters.customer?.id, undefined, false, isSimpleType);
                            reportCount = l;
                            break;
                        case 30:
                            const { data: m } = await customerDriverIdentifierExportResponse(token, status, customerId, reportType, isSimpleType);
                            reportCount = m;
                            break;
                        case INTEREST_POINTS_REPORT_ID:
                            const { data: n } = await interestPointFindAllExportResponse(token, customerId, status, reportType, isSimpleType);
                            reportCount = n;
                            break;
                        case INTEREST_POINTS_NEAR_VEHICLE_REPORT_ID:
                            const { data: o } = await interestPointNearVehicleExportResponse(token, customerId, nearVehicleSelected?.id!!, status, reportType, maxDistanceKm ? Number(maxDistanceKm) : undefined, isSimpleType);
                            reportCount = o;
                            break;
                        default:
                            break;
                    }

                    if (reportCount.byteLength === 0) {
                        setTextValidation("Nenhum dado para mostrar no relatório.");
                        setStatusMessage("warn");
                        setFieldsIsValid(false);
                    } else {
                        setTextValidation("Relatório gerado com sucesso.");
                        setStatusMessage("success");
                        setFieldsIsValid(false);
                        dataBuffer = reportCount;
                    }
                } else {
                    const { data } = await getReportWithFiltersResponse(
                        token,
                        filters,
                        status,
                        reportType,
                        currentParameters?.isViewingAll,
                        isSimpleType
                    );

                    if ((data as ArrayBuffer).byteLength === 0) {
                        setTextValidation("Nenhum dado para mostrar no relatório.");
                        setStatusMessage("warn");
                        setFieldsIsValid(false);
                    } else {
                        setTextValidation("Relatório gerado com sucesso.");
                        setStatusMessage("success");
                        setFieldsIsValid(false);
                        dataBuffer = data;
                    }
                }

                setTimeout(() => {
                    setLoading(false);
                    setStatusMessage("warn");
                    setIsToastVisible(false);
                    setTextValidation("");
                    setIsOpenReportMap(false);
                    setReportMapData({} as any);
                    setStartDate(null);
                    setEndDate(null);
                    setReport(dataBuffer);
                    setExportType(type);
                }, 3000);
            } catch (error: any) {
                const reason = getApiErrorMessage(error, "Erro ao gerar o relatório. Tente novamente.");

                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(reason);
            }
        },
        [
            secretary?.id,
            selectedHistoryDevice?.id,
            selectedHistoryVehicle,
            isViewingAll,
            repeatHeader,
            driversList,
            selectedDrivers,
            cookies.token,
            cookies.selectedParameters,
            selectedReport,
            startDate,
            endDate,
            groupVehicles,
            selectedGroupsList,
            onlyActives,
            onlyInactives,
            customer.id,
            department.id,
            getCurrentUser.configs.isManager,
            getCurrentUser.configs.customerSettings?.utcZone,
            nearVehicleSelected?.id,
            maxDistanceKm,
        ]
    );

    const getReportHeatMapData = (
        data: any
    ): FeatureCollection<Point, EarthquakeProps> => {
        const geojson = data.map((item: any) => ({
            lat: item?.first?.lat,
            lng: item?.first?.lng,
            mag: item?.second,
        }));
        const response = constructGeoJson(geojson);
        return response;
    };

    const getReportMap = useCallback(async () => {
        setLoading(true);
        clearRouteCache();

        const token = cookies.token || sessionStorage.getItem("token");
        const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer.id : customer.id;
        const departmentId = !getCurrentUser.configs.isManager ? currentParameters?.department.id : department.id;
        const reportDateRange = getReportDateRangeMillis({
            startDate,
            endDate,
            isManager: getCurrentUser.configs.isManager,
            authenticatedCustomerUtcZone:
                getCurrentUser.configs.customerSettings?.utcZone,
        });

        const filters: ReportType = {
            name: "report map",
            ...reportDateRange,
            vehicles: groupVehicles.length > 0 ? groupVehicles.map((car) => Number(car)) : [selectedHistoryVehicle?.id!!],
            customerId: customerId,
            deviceId: selectedHistoryDevice?.id ?? null,
            departmentId: departmentId,
        };
        const status = "activated";
        try {
            let dataReport = null;
            if (reportType === "map" && selectedReport.id === 2) {
                const { data } = await gerenatePositionsHeatMapByVehicleResponse(token, filters);
                dataReport = data;
                setReportHeatMapData(dataReport);
            } else if (selectedReport.id === 4) {
                const { data } = await findAllTravelsWithFiltersResponse(
                    token,
                    filters,
                    false,
                    showActiveVehicles ? "activated" : "deactivated"
                );
                const travels = Array.isArray(data) && data.length > 0
                    ? data[0].events || []
                    : (data?.events || []);

                setReportTravelData(travels);
                setIsOpenReportMap(true);
            } else {
                const { data } = await generatePositionsMapByVehicle(
                    token,
                    filters,
                    status
                );
                dataReport = data as VehicleWithPositionsType;
                setReportMapData(dataReport);
            }

            if ((selectedReport.id === 1 && !dataReport?.positions?.length)
                || (selectedReport.id === 2 && !dataReport?.length)) {
                setLoading(false);
                setTextValidation("Nenhum dado para mostrar no relatório.");
                setStatusMessage("warn");
                setFieldsIsValid(false);
                return;
            }

            setTextValidation("Relatório gerado com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);
            setIsOpenReportMap(true);

            setTimeout(() => {
                setLoading(false);
                setStatusMessage("warn");
                setIsToastVisible(false);
                setTextValidation("");
                setIsOpenDetails(false);
            }, 3000);
        } catch (error: any) {
            setLoading(false);
            setFieldsIsValid(false);
            setStatusMessage("warn");
            setTextValidation(getApiErrorMessage(error, "Erro ao gerar o relatório de mapa. Tente novamente."));

            setTimeout(() => {
                setLoading(false);
                setStatusMessage("warn");
                setIsToastVisible(false);
                setTextValidation("");
            }, 3000);
        }
    }, [
        cookies.token,
        reportType,
        selectedReport.id,
        currentParameters?.customer.id,
        currentParameters?.department.id,
        customer.id,
        department.id,
        getCurrentUser.configs.isManager,
        getCurrentUser.configs.customerSettings?.utcZone,
        startDate,
        endDate,
        groupVehicles,
        showActiveVehicles,
        selectedHistoryDevice?.id,
        selectedHistoryVehicle?.id
    ]);

    useEffect(() => {
        if (report.byteLength > 0) {
            const typeExport =
                exportType === "pdf"
                    ? "application/pdf"
                    : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            const file = new Blob([report], { type: typeExport });
            const fileURL = URL.createObjectURL(file);

            if (exportType === "pdf") {
                setPdfUrl(fileURL);
                setPdfFileName(`Relatorio - ${selectedReport.name} - ${dayjs().format("DD-MM-YYYY HH-mm")}.pdf`);
                setIsPdfModalOpen(true);
            } else {
                window.open(fileURL);
            }
            setReport(new ArrayBuffer(0));
        }
    }, [report, exportType, selectedReport.name]);

    useEffect(() => {
        setFilteredList(
            getFilteredList(["name", "description"], reportLists, query)
        );
    }, [reportLists, query]);

    const handleChange = (event: any, page: any) => {
        setPage(page);
        dataPage.jump(page);
    };

    const handleUpperChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        if (isTechnician) return;
        setUpperTabValue(newValue);
        if (newValue === 4) {
            setReportType("common");
            setReportList(reportCountManagerItens);
            setLoading(false);
        }
    };

    const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        if (isTechnician) return;
        setTabValue(newValue);
    };

    useEffect(() => {
        if (isTechnician) {
            setReportType("common");
            setReportList(reportTechnicianItens);
            setLoading(false);
            return;
        }
        const listCustomerReport = uppertTabValue === 5;
        if ((listCustomerReport) || (!getCurrentUser.configs.isManager)) {
            if (tabValue === 1 && getCurrentUser.accessProfile.id !== Number(PROFILE_ACESSES.DRIVER)) {
                setLoading(true);
                setReportType("common");
                setTimeout(() => {
                    setReportList(reportAnaliticItens);
                    setLoading(false);
                }, 2000);
            } else if (tabValue === 2 && getCurrentUser.accessProfile.id !== Number(PROFILE_ACESSES.DRIVER)) {
                setLoading(true);
                setReportType("common");
                setTimeout(() => {
                    setReportList(reportCountItens);
                    setLoading(false);
                }, 2000);
            } else if (tabValue === 3 && getCurrentUser.accessProfile.id !== Number(PROFILE_ACESSES.DRIVER)) {
                setLoading(true);
                setTimeout(() => {
                    setReportType("map");
                    setReportList(canViewPlannedRoutes ? reportMapItens : reportMapItens.filter((item) => item.id !== 5));
                    setLoading(false);
                }, 2000);
            } else if (tabValue === 0) {
                setReportType("common");
                getAllReportList();
            }
        } else {
            setReportType("common");
            setReportList(reportCountManagerItens);
            setLoading(false);
        }
    }, [tabValue, getAllReportList, uppertTabValue, getCurrentUser.configs.isManager, getCurrentUser.accessProfile.id, isTechnician, canViewPlannedRoutes]);

    const renderMapOptions = useMemo(() => {
        const eventPositions = reportMapData?.positions
            ?.slice()
            .sort(
                (a, b) =>
                    new Date(a.eventTime).getTime() -
                    new Date(b.eventTime).getTime()
            )
            .filter((item) => Boolean(item.eventType)) ?? [];

        return (
            <Box
                className="tw-flex tw-flex-col tw-items-start tw-transition-all tw-duration-300 tw-ease-gtr-smooth"
                sx={{
                    position: "absolute",
                    zIndex: 99999,
                    left: { xs: 8, sm: 12 },
                    top: { xs: 62, sm: 69 },
                    maxWidth: "calc(100vw - 24px)",
                }}
            >
                <Box
                    className="tw-flex tw-items-center tw-gap-1 tw-shadow-xl tw-backdrop-blur-md"
                    sx={{
                        p: 0.5,
                        border: "1px solid rgba(255, 255, 255, 0.16)",
                        borderRadius: 3,
                        backgroundImage: "linear-gradient(135deg, rgba(0, 108, 119, 0.96), rgba(9, 65, 74, 0.96))",
                        boxShadow: "0 12px 32px rgba(9, 65, 74, 0.24)",
                        "& .MuiIconButton-root": {
                            width: 40,
                            height: 40,
                            color: "#fff",
                            borderRadius: 2,
                            transition: "background-color 180ms ease, color 180ms ease, transform 180ms ease",
                        },
                        "& .MuiIconButton-root:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.13)",
                            transform: "translateY(-1px)",
                        },
                    }}
                >
                    <Tooltip title={showPaths ? "Ocultar trajeto" : "Exibir trajeto"} arrow placement="right">
                        <IconButton
                            aria-label={showPaths ? "Ocultar trajeto" : "Exibir trajeto"}
                            onClick={() => {
                                setShowPaths(!showPaths);
                            }}
                        >
                            <TimelineOutlined sx={{ color: showPaths ? "#00b700" : "#fff" }} />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title={playTracking ? "Pausar reprodução" : "Reproduzir trajeto"} arrow placement="right">
                        <IconButton
                            aria-label={playTracking ? "Pausar reprodução" : "Reproduzir trajeto"}
                            onClick={() => {
                                setPlayTracking(!playTracking);
                            }}
                        >
                            {!playTracking ? <PlayCircleOutlined /> : <PauseCircleOutlined />}
                        </IconButton>
                    </Tooltip>
                </Box>

                {eventPositions.length > 0 && (
                    <Box
                        className="tw-mt-2 tw-overflow-y-auto tw-rounded-xl tw-border tw-border-slate-200/80 tw-bg-white/95 tw-p-1.5 tw-shadow-xl tw-backdrop-blur-md"
                        sx={{
                            width: { xs: "min(270px, calc(100vw - 24px))", sm: 280 },
                            maxHeight: { xs: "calc(100vh - 190px)", sm: 540 },
                            scrollbarWidth: "thin",
                            scrollbarColor: "#94a3b8 transparent",
                            "&::-webkit-scrollbar": { width: 5 },
                            "&::-webkit-scrollbar-track": { background: "transparent" },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#94a3b8",
                                borderRadius: 8,
                            },
                        }}
                    >
                        {eventPositions.map((item, index) => (
                            <Box
                                key={`${item.eventTime}-${index}`}
                                className="tw-mb-1.5 tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2.5 tw-py-2 last:tw-mb-0"
                            >
                                <Box className="tw-flex tw-items-start tw-justify-between tw-gap-2">
                                    <Typography variant="caption" sx={{ color: "#09414a", fontWeight: 700, lineHeight: 1.25 }}>
                                        {item.driverName || "Motorista não informado"}
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: "#64748b", whiteSpace: "nowrap", lineHeight: 1.25 }}>
                                        {item.lastUpdate}
                                    </Typography>
                                </Box>
                                <Typography variant="caption" sx={{ display: "block", mt: 0.5, color: "#00a100", fontWeight: 600, lineHeight: 1.3 }}>
                                    {eventHandlerMessage(item.eventType!)}
                                </Typography>
                                <Tooltip title={item.address || "Endereço não informado"} arrow placement="right">
                                    <Typography
                                        variant="caption"
                                        noWrap
                                        sx={{ display: "block", mt: 0.35, color: "#64748b", lineHeight: 1.3 }}
                                    >
                                        {item.address || "Endereço não informado"}
                                    </Typography>
                                </Tooltip>
                            </Box>
                        ))}
                    </Box>
                )}
            </Box>
        );
    }, [showPaths, playTracking, reportMapData?.positions]);

    const RenderMapModal = useMemo(() => {
        const isCenteredModal = [1, 2, 3, 4].includes(selectedReport.id);
        const hasSidePanel = [3, 4].includes(selectedReport.id);

        const MapContent = (
            <Box
                className="tw-relative tw-h-full tw-min-h-0 tw-w-full tw-overflow-hidden tw-rounded-xl tw-border tw-border-slate-200 tw-bg-slate-100 tw-shadow-sm"
            >
                {loading ? (
                    <Box className="tw-flex tw-h-full tw-min-h-[280px] tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-bg-slate-100">
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height="100%"
                            animation="wave"
                            sx={{ position: "absolute", inset: 0, bgcolor: "grey.200" }}
                        />
                        <Box className="tw-relative tw-z-10 tw-rounded-lg tw-bg-white/90 tw-px-4 tw-py-2 tw-shadow-sm tw-backdrop-blur-sm">
                            <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#475569" }}>
                                Preparando visualização do mapa...
                            </Typography>
                        </Box>
                    </Box>
                ) : (
                    <GPositionsMap
                        mapRef={mapRef}
                        center={
                            addresses[0]?.localLat
                                ? { lat: addresses[0].localLat, lng: addresses[0].localLng }
                                : { lat: -15.5986686, lng: -56.0991301 }
                        }
                        zoom={14}
                        style={{ width: "100%", height: "100%" }}
                    >
                        <>
                            {selectedReport.id === 1 && renderMapOptions}
                            {selectedReport.id === 1 && (
                                <LiveRoutesTracker
                                    data={reportMapData}
                                    showPaths={showPaths}
                                    tracking={true}
                                    play={playTracking}
                                />
                            )}
                            {selectedReport.id === 2 && reportHeatMapData[0]?.first && (
                                <Heatmap
                                    geojson={getReportHeatMapData(reportHeatMapData)}
                                    opacity={0.8}
                                    radius={30}
                                    key={1}
                                />
                            )}
                            {selectedReport.id === 3 && (
                                <Directions
                                    positions={positions}
                                    onHandleChange={(updatedPositions) => {
                                        setAddresses(prev => {
                                            if (updatedPositions.length !== prev.length) return prev;
                                            return prev.map((address, index) => ({
                                                ...address,
                                                localLat: updatedPositions[index]?.lat ?? address.localLat,
                                                localLng: updatedPositions[index]?.lng ?? address.localLng,
                                            }));
                                        });
                                    }}
                                />
                            )}
                            {selectedReport.id === 4 && reportTravelData.length > 0 && (
                                <AllTripsMapLayer
                                    trips={reportTravelData}
                                    selectedTrip={selectedTrip}
                                    vehicleType={vehicleList.find(v => v.id === (groupVehicles.length > 0 ? Number(groupVehicles[0]) : -1))?.vehicleTypeName || "carro"}
                                    approxTrip={approxTrip}
                                />
                            )}
                        </>
                    </GPositionsMap>
                )}
            </Box>
        );

        const TripList = (
            <Paper className="print-trip-list" sx={{ width: '100%', height: '100%', overflow: 'hidden', borderRadius: '5px', border: '1px solid #e0e0e0', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    background: '#0FB403',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '0.85rem',
                    textAlign: 'center',
                    borderBottom: '2px solid #087002',
                    py: 1
                }}>
                    <Box>Resumo da Viagem</Box>
                    <Box>Distância</Box>
                </Box>
                <Box className="print-overflow-visible" sx={{
                    flex: 1, overflowY: 'auto', background: '#f9f9f9',
                    scrollbarWidth: "thin",
                    scrollbarColor: "#c1c1c1 transparent",
                    "&::-webkit-scrollbar": { width: "5px" },
                    "&::-webkit-scrollbar-track": { background: "transparent" },
                    "&::-webkit-scrollbar-thumb": { backgroundColor: "#c1c1c1", borderRadius: "5px" }
                }}>
                    {loading ? (
                        Array.from(new Array(5)).map((_, index) => (
                            <Box key={index} sx={{ p: 1.5, borderBottom: '1px solid #eee' }}>
                                <Skeleton variant="text" width="60%" height={20} sx={{ mb: 1 }} />
                                <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: '4px' }} />
                                <Box sx={{ mb: 1.5 }}>
                                    <Skeleton variant="text" width="30%" height={15} />
                                    <Skeleton variant="text" width="70%" height={20} />
                                </Box>
                                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 1 }}>
                                    <Box>
                                        <Skeleton variant="text" width="60%" height={15} />
                                        <Skeleton variant="text" width="80%" height={20} />
                                    </Box>
                                    <Box>
                                        <Skeleton variant="text" width="60%" height={15} />
                                        <Skeleton variant="text" width="80%" height={20} />
                                    </Box>
                                    <Box>
                                        <Skeleton variant="text" width="60%" height={15} />
                                        <Skeleton variant="text" width="80%" height={20} />
                                    </Box>
                                </Box>
                            </Box>
                        ))
                    ) : (
                        reportTravelData.map((trip, idx) => {
                            const nextTrip = reportTravelData[idx + 1];
                            const stoppedBeforeNext = nextTrip ? trip?.stoppedTime : null;
                            return (
                                <Box key={idx} className={selectedTrip && selectedTrip !== trip ? "print-hide" : ""}>
                                    <Box
                                        onClick={() => {
                                            setSelectedTrip(prev => prev === trip ? null : trip);
                                            setApproxTrip(null);
                                        }}
                                        sx={{
                                            borderBottom: stoppedBeforeNext ? 'none' : '1px solid #eee',
                                            p: 1.5,
                                            cursor: 'pointer',
                                            background: selectedTrip === trip ? '#e8f5e9' : 'white',
                                            '&:hover': { background: '#f1f1f1' },
                                            transition: 'background 0.2s',
                                            borderLeft: selectedTrip === trip ? '3px solid #0FB403' : '3px solid transparent',
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                                            <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#555', fontSize: '0.7rem' }}>
                                                VIAGEM #{idx + 1}
                                            </Typography>
                                            <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#0FB403', fontSize: '0.75rem' }}>
                                                {safeNum(trip?.distance).toFixed(1)} km
                                            </Typography>
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 0.5 }}>
                                            <Box sx={{ width: 8, height: 8, borderRadius: 5, background: '#4caf50', mr: 1, mt: 0.3, flexShrink: 0 }} />
                                            <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
                                                <Typography variant="caption" display="block" sx={{ color: '#888', fontSize: '0.6rem', lineHeight: 1.2 }}>INÍCIO — {trip?.startTime}</Typography>
                                                <Typography variant="caption" sx={{ color: '#333', fontSize: '0.72rem', wordBreak: 'break-word' }}>
                                                    {trip?.startAddress || "Endereço não identificado"}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                            <Box sx={{ width: 8, height: 8, borderRadius: '50%', background: '#f44336', mr: 1, mt: 0.3, flexShrink: 0 }} />
                                            <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
                                                <Typography variant="caption" display="block" sx={{ color: '#888', fontSize: '0.6rem', lineHeight: 1.2 }}>FIM — {trip?.endTime}</Typography>
                                                <Typography variant="caption" sx={{ color: '#333', fontSize: '0.72rem', wordBreak: 'break-word' }}>
                                                    {trip?.endAddress || "Endereço não identificado"}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Divider sx={{ my: 0.5, opacity: 0.4 }} />

                                        <Box sx={{ mt: 1.5 }}>
                                            <Box sx={{ mb: 1.5, pb: 1, borderBottom: '1px solid #f0f0f0' }}>
                                                <Typography variant="caption" display="block" sx={{ color: '#888', fontSize: '0.6rem', fontWeight: 600, mb: 0.5 }}>MOTORISTA</Typography>
                                                <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '0.75rem', color: '#333' }}>
                                                    {trip?.driverName && trip?.driverUniqueId && trip?.driverName !== "null" && trip?.driverUniqueId !== "null"
                                                        ? `${trip.driverName} (${trip.driverUniqueId})`
                                                        : (trip?.driverName && trip?.driverName !== "null" ? trip.driverName : (trip?.driverUniqueId && trip?.driverUniqueId !== "null" ? trip.driverUniqueId : "iButton ausente"))}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1.1fr 1.1fr', gap: 1 }}>
                                                <Box>
                                                    <Typography variant="caption" display="block" sx={{ color: '#888', fontSize: '0.6rem', fontWeight: 600 }}>DURAÇÃO</Typography>
                                                    <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '0.7rem', color: '#1565c0' }}>{formatDuration(safeNum(trip?.duration) * 60)}</Typography>
                                                </Box>
                                                <Box>
                                                    <Typography variant="caption" display="block" sx={{ color: '#888', fontSize: '0.6rem', fontWeight: 600 }}>ODO INÍCIO</Typography>
                                                    <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '0.7rem', color: '#555' }}>{safeNum(trip?.startOdometer).toFixed(1)} km</Typography>
                                                </Box>
                                                <Box>
                                                    <Typography variant="caption" display="block" sx={{ color: '#888', fontSize: '0.6rem', fontWeight: 600 }}>ODO FIM</Typography>
                                                    <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '0.7rem', color: '#555' }}>{safeNum(trip?.endOdometer).toFixed(1)} km</Typography>
                                                </Box>
                                            </Box>
                                        </Box>

                                        {/* Botões de Ação */}
                                        <Box className="print-hide" sx={{ mt: 1, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                                            <Button
                                                size="small"
                                                variant={approxTrip === trip ? 'contained' : 'outlined'}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setApproxTrip(prev => prev === trip ? null : trip);
                                                    setSelectedTrip(trip);
                                                }}
                                                sx={{
                                                    fontSize: '0.6rem',
                                                    py: 0.3,
                                                    px: 1,
                                                    borderColor: '#ff6f00',
                                                    color: approxTrip === trip ? '#fff' : '#ff6f00',
                                                    backgroundColor: approxTrip === trip ? '#ff6f00' : 'transparent',
                                                    '&:hover': {
                                                        backgroundColor: '#ff6f00',
                                                        color: '#fff',
                                                    },
                                                    minWidth: 0,
                                                    textTransform: 'none',
                                                }}
                                            >
                                                {approxTrip === trip ? '✓ Rota maps' : 'Rota aproximada'}
                                            </Button>
                                        </Box>
                                    </Box>

                                    {stoppedBeforeNext !== null && (
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            px: 2,
                                            py: 0.6,
                                            background: '#fff8e1',
                                            borderTop: '1px dashed #ffe082',
                                            borderBottom: '1px dashed #ffe082',
                                        }}>
                                            <Box sx={{ width: 6, height: 6, borderRadius: 5, background: '#ffa726', flexShrink: 0 }} />
                                            <Typography variant="caption" sx={{ color: '#e65100', fontSize: '0.65rem', fontWeight: 600 }}>
                                                Parado por {formatDuration(safeNum(stoppedBeforeNext) * 60)} antes da próxima viagem
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            );
                        })
                    )}
                </Box>

                {/* Totals footer */}
                <Box sx={{
                    borderTop: '2px solid #e0e0e0',
                    background: '#f0f4f0',
                    px: 1.5,
                    py: 1,
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gap: 0.5,
                }}>
                    <Box sx={{ textAlign: 'center' }}>
                        <Typography variant="caption" display="block" sx={{ color: '#666', fontSize: '0.6rem', fontWeight: 600, textTransform: 'uppercase' }}>Total km</Typography>
                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#0FB403', fontSize: '0.8rem' }}>
                            {reportTravelData.reduce((acc, t) => acc + safeNum(t.distance), 0).toFixed(1)} km
                        </Typography>
                    </Box>
                    <Box sx={{ textAlign: 'center', borderLeft: '1px solid #d0d0d0', borderRight: '1px solid #d0d0d0' }}>
                        <Typography variant="caption" display="block" sx={{ color: '#666', fontSize: '0.6rem', fontWeight: 600, textTransform: 'uppercase' }}>Tempo viagem</Typography>
                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#1565c0', fontSize: '0.8rem' }}>
                            {formatDuration(reportTravelData.reduce((acc, t) => acc + safeNum(t.duration), 0) * 60)}
                        </Typography>
                    </Box>
                    <Box sx={{ textAlign: 'center' }}>
                        <Typography variant="caption" display="block" sx={{ color: '#666', fontSize: '0.6rem', fontWeight: 600, textTransform: 'uppercase' }}>Tempo parado</Typography>
                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#e65100', fontSize: '0.8rem' }}>
                            {formatDuration(reportTravelData.reduce((acc, t) => acc + safeNum(t.stoppedTime), 0) * 60)}
                        </Typography>
                    </Box>
                </Box>
            </Paper>
        );

        const BestRoutePanel = (
            <Paper className="report-map-side-panel" sx={{ width: '100%', height: '100%', p: 2, borderRadius: '5px', border: '1px solid #e0e0e0', display: 'flex', flexDirection: 'column', gap: 2, overflowY: 'auto' }}>
                <Typography className="report-map-panel-title" variant="subtitle1" sx={{ fontWeight: 'bold', color: '#0FB403', mb: 1, borderBottom: '2px solid #0FB403', pb: 1 }}>
                    Melhor Rota
                </Typography>

                {addresses.map((address, index) => {
                    const isOrigin = index === 0;
                    const isDestination = index === addresses.length - 1;
                    const label = isOrigin ? "PONTO DE PARTIDA" : isDestination ? "PONTO DE DESTINO" : `PARADA ${index}`;

                    return (
                        <Box key={index}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Typography variant="caption" sx={{ color: '#666' }}>{label}</Typography>
                                {!isOrigin && !isDestination && (
                                    <Tooltip title="Remover parada" arrow placement="top">
                                        <IconButton aria-label="Remover parada" size="small" onClick={() => removeStop(index)} sx={{ padding: 0 }}>
                                            <CloseOutlined sx={{ fontSize: 16, color: '#dc3545' }} />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Box>
                            <Autocomplete
                                freeSolo
                                loading={!!addressLoadingMap[index]}
                                inputValue={address.query ?? ""}
                                filterOptions={(x) => x}
                                options={(address.predictionResults ?? []).map((option) => option.display_name)}
                                onInputChange={handleAddressInputChange(index)}
                                onChange={handleAddressSelect(index)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder={isOrigin ? "Endereço de partida" : isDestination ? "Endereço de destino" : "Endereço da parada"}
                                        variant="outlined"
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                            />
                        </Box>
                    );
                })}

                <Button
                    type="button"
                    variant="outlined"
                    onClick={addStop}
                    disabled={addresses.length >= MAX_STOPS}
                    sx={{
                        fontFamily: "Prometo",
                        borderColor: '#0FB403',
                        color: '#0FB403',
                        '&:hover': { borderColor: '#087002', background: '#e8f5e9' },
                    }}
                >
                    + Adicionar parada
                </Button>

                <Box className="report-map-hint" sx={{ mt: 'auto', p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                    <Typography variant="caption" color="textSecondary">
                        Selecione os pontos acima para traçar a melhor rota entre eles automaticamente.
                    </Typography>
                </Box>
            </Paper>
        );

        return (
            <Rmodal
                className="tw-font-prometo"
                open={isOpenReportMap}
                handleClose={() => {
                    handleClose();
                }}
            >
                <Paper
                    elevation={3}
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="report-map-dialog-title"
                    className="report-map-modal tw-flex tw-flex-col tw-overflow-hidden tw-rounded-2xl tw-border tw-border-slate-200/80 tw-bg-slate-100 tw-font-prometo tw-shadow-2xl"
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        border: "none",
                        color: "black",
                        lineBreak: "anywhere",
                        fontFamily: "Prometo",
                        width: { xs: "calc(100vw - 16px)", sm: "94vw", md: isHiddenMenu ? "82vw" : "78vw", lg: isHiddenMenu ? "74vw" : "68vw" },
                        height: isCenteredModal ? { xs: "92dvh", sm: "88vh" } : "auto",
                        maxHeight: "92dvh",
                    }}
                >
                    <Box
                        className="tw-flex tw-flex-none tw-items-center tw-justify-between tw-gap-3 tw-bg-gtr-sidebar tw-px-3.5 tw-py-3 tw-text-white sm:tw-px-4"
                    >
                        <Box className="tw-flex tw-min-w-0 tw-items-center tw-gap-2.5">
                            <Box className="tw-flex tw-h-9 tw-w-9 tw-flex-none tw-items-center tw-justify-center tw-rounded-xl tw-bg-white/10">
                                <TimelineOutlined sx={{ fontSize: 20 }} />
                            </Box>
                            <Box sx={{ minWidth: 0 }}>
                                <Typography id="report-map-dialog-title" noWrap sx={{ color: "inherit", fontSize: 14, fontWeight: 800, lineHeight: 1.2 }}>
                                    {selectedReport.name || "Relatório em mapa"}
                                </Typography>
                                <Typography noWrap sx={{ mt: 0.35, color: "rgba(255,255,255,0.7)", fontSize: 10.5, fontWeight: 600 }}>
                                    VISUALIZAÇÃO GEOGRÁFICA DO RELATÓRIO
                                </Typography>
                            </Box>
                        </Box>
                        <Tooltip title="Fechar" arrow placement="left">
                            <IconButton
                                aria-label="Fechar relatório em mapa"
                                size="small"
                                onClick={() => {
                                    if (!isToastVisible) handleClose();
                                }}
                                className="!tw-bg-white/10 !tw-text-white tw-transition-all tw-duration-200 hover:!tw-bg-red-500/70"
                            >
                                <CloseOutlined fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    <Box className="tw-flex tw-min-h-0 tw-flex-1 tw-p-2.5 sm:tw-p-3">
                        {isOpenReportMap && (
                            hasSidePanel ? (
                                <Box
                                    className="tw-grid tw-h-full tw-min-h-0 tw-w-full tw-gap-3"
                                    sx={{
                                        gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "minmax(260px, 31%) minmax(0, 1fr)" },
                                        gridTemplateRows: { xs: "minmax(210px, 38%) minmax(260px, 1fr)", md: "minmax(0, 1fr)" },
                                    }}
                                >
                                    <Box className="tw-min-h-0 tw-overflow-hidden">
                                        {selectedReport.id === 3 && BestRoutePanel}
                                        {selectedReport.id === 4 && TripList}
                                    </Box>
                                    <Box className="tw-min-h-0 tw-overflow-hidden">
                                        {MapContent}
                                    </Box>
                                </Box>
                            ) : (
                                MapContent
                            )
                        )}
                    </Box>

                    <Box
                        className="tw-flex tw-flex-none tw-flex-wrap tw-items-center tw-justify-between tw-gap-2 tw-border-t tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2.5 sm:tw-px-4"
                        sx={{ position: "relative", zIndex: 2 }}
                    >
                        {selectedReport.id === 4 ? (
                            <Box className="tw-flex tw-min-w-0 tw-items-center tw-gap-2">
                                <Tooltip title="Este relatório de movimento e parada considera a primeira posição como ignição ligada e a última posição como ignição desligada, ou seja, é pinado a primeira e a última posição da viagem. Caso queira mais detalhes, deve-se ver o relatório de posições em mapa." arrow placement="top">
                                    <IconButton aria-label="Informações sobre o relatório de movimento e parada" size="small" sx={{ color: "#006c77" }}>
                                        <InfoOutlined fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                {selectedTrip && (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        startIcon={<VisibilityOutlined />}
                                        onClick={() => {
                                            setSelectedTrip(null);
                                            setApproxTrip(null);
                                        }}
                                        className="!tw-border-gtr-green !tw-text-gtr-green hover:!tw-border-gtr-green-hover hover:!tw-bg-green-50"
                                        sx={{ textTransform: "none", fontFamily: "Prometo", fontWeight: 700 }}
                                    >
                                        Ver Todas as Viagens
                                    </Button>
                                )}
                            </Box>
                        ) : (
                            <Box></Box>
                        )}
                        <Box className="tw-ml-auto tw-flex tw-items-center tw-justify-end tw-gap-2">
                            <Button
                                type="button"
                                variant="contained"
                                startIcon={<CloseOutlined />}
                                onClick={() => {
                                    if (!isToastVisible) {
                                        handleClose();
                                    }
                                }}
                                sx={{
                                    minWidth: 132,
                                    minHeight: 44,
                                    borderRadius: 2,
                                    color: "#ffff",
                                    backgroundColor: "#dc3545",
                                    fontFamily: "Prometo",
                                    textTransform: "none",
                                    boxShadow: "none",
                                    transition: "transform 200ms ease, box-shadow 200ms ease",
                                    "&:hover": {
                                        backgroundColor: "#dc3545",
                                        boxShadow: "0 8px 18px rgba(220,53,69,0.22)",
                                        transform: "translateY(-1px)",
                                    },
                                }}
                            >
                                Fechar
                            </Button>
                            {(selectedReport.id === 3 || (selectedReport.id === 4 && reportTravelData.length > 0)) && (
                                <Button
                                    type="button"
                                    variant="contained"
                                    startIcon={<SendToMobileOutlined />}
                                    onClick={() => {
                                        if (!isToastVisible) {
                                            let mapsUrl = "";
                                            if (selectedReport.id === 3) {
                                                mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}${waypoints ? `&waypoints=${waypoints}` : ""}&travelmode=driving`;
                                            } else if (selectedReport.id === 4) {
                                                const first = reportTravelData[0];
                                                const last = reportTravelData[reportTravelData.length - 1];
                                                const travelWaypoints = reportTravelData.slice(1, -1).map(t => `${t.startLat},${t.startLng}`).join('|');
                                                mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${first.startLat},${first.startLng}&destination=${last.endLat},${last.endLng}${travelWaypoints ? `&waypoints=${travelWaypoints}` : ''}&travelmode=driving`;
                                            }
                                            if (selectedReport.id === 4) {
                                                window.open(mapsUrl, "_blank");
                                            } else {
                                                const message = encodeURIComponent(`Veja a rota: ${mapsUrl}`);
                                                const whatsappUrl = `https://wa.me/?text=${message}`;
                                                window.open(whatsappUrl, "_blank");
                                            }
                                        }
                                    }}
                                    sx={{
                                        minWidth: 132,
                                        minHeight: 44,
                                        borderRadius: 2,
                                        color: "#ffff",
                                        backgroundColor: "#00B700",
                                        fontFamily: "Prometo",
                                        textTransform: "none",
                                        boxShadow: "none",
                                        transition: "transform 200ms ease, box-shadow 200ms ease",
                                        "&:hover": {
                                            backgroundColor: "#00B700",
                                            boxShadow: "0 8px 18px rgba(0,183,0,0.22)",
                                            transform: "translateY(-1px)",
                                        },
                                    }}
                                >
                                    {selectedReport.id === 3 ? "Exportar rota" : "Abrir no Maps"}
                                </Button>
                            )}
                        </Box>
                    </Box>
                </Paper>
            </Rmodal>
        );
    }, [
        selectedReport.id,
        selectedReport.name,
        loading,
        addresses,
        renderMapOptions,
        reportMapData,
        showPaths,
        playTracking,
        reportHeatMapData,
        positions,
        selectedTrip,
        approxTrip,
        vehicleList,
        nearVehicleSelected,
        maxDistanceKm,
        reportTravelData,
        addStop,
        isOpenReportMap,
        isHiddenMenu,
        groupVehicles,
        addressLoadingMap,
        handleAddressInputChange,
        handleAddressSelect,
        removeStop,
        handleClose,
        isToastVisible,
        origin,
        destination,
        waypoints
    ]);

    const DetailsModal = useMemo(() => {
        return (
            <Rmodal
                open={isOpenDetails && !loading}
                hiddenBackdrop={false}
                toast={
                    <Toast
                        ref={toastModalRef}
                        position="center"
                        onShow={() => {
                            setIsToastVisible(true);
                            if (validationText) {
                                setTimeout(() => {
                                    setFieldsIsValid(true);
                                    setIsToastVisible(false);
                                }, 3000);
                            }
                        }}
                    />
                }
            >
                <Paper
                    role="dialog"
                    aria-labelledby="report-filter-dialog-title"
                    className="parameters-container tw-overflow-hidden tw-rounded-2xl tw-shadow-2xl tw-transition-all tw-duration-300 tw-ease-gtr-smooth"
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        display: "flex",
                        flexDirection: "column",
                        width: { xs: "calc(100vw - 24px)", sm: isDeviceHistoryMode ? "min(92vw, 900px)" : "min(86vw, 680px)" },
                        maxWidth: isDeviceHistoryMode ? 900 : 680,
                        maxHeight: "calc(100dvh - 24px)",
                        padding: 0,
                        overflow: "hidden",
                        border: "none",
                        borderRadius: 4,
                        backgroundColor: "#ffff",
                        boxShadow: "0 24px 70px rgba(0, 0, 0, 0.28)",
                        alignItems: "stretch",
                        justifyContent: "flex-start",
                        "& .report-filter-body .MuiFormControl-root": { width: "100%" },
                        "& .report-filter-body .MuiAutocomplete-root": { width: "100%" },
                        "& .report-filter-body .MuiOutlinedInput-root": {
                            minHeight: 56,
                            borderRadius: 2,
                            backgroundColor: "#ffffff",
                            transition: "box-shadow 200ms ease, border-color 200ms ease",
                            "& fieldset": { borderColor: "rgba(0, 63, 74, 0.24)" },
                            "&:hover fieldset": { borderColor: "#006C77" },
                            "&.Mui-focused": { boxShadow: "0 0 0 3px rgba(0, 183, 0, 0.12)" },
                            "&.Mui-focused fieldset": { borderColor: "#00B700" },
                            "&.Mui-disabled": { backgroundColor: "rgba(0, 63, 74, 0.04)" },
                        },
                        "& .report-filter-body .MuiInputLabel-root": { fontFamily: "Prometo" },
                        "& .report-filter-body .MuiFormControlLabel-root": {
                            marginLeft: 0,
                            marginRight: 0,
                            paddingLeft: 1,
                            paddingRight: 1,
                            paddingTop: 0.5,
                            paddingBottom: 0.5,
                            borderRadius: 2,
                            transition: "background-color 200ms ease",
                            "&:hover": { backgroundColor: "rgba(0, 63, 74, 0.05)" },
                            "& .MuiFormControlLabel-label": { fontFamily: "Prometo" },
                        },
                        "& .report-filter-body .MuiCheckbox-root": {
                            color: "#006C77",
                            "&.Mui-checked": { color: "#00B700" },
                        },
                        "& .report-filter-body > [class*='col-']": {
                            minWidth: 0,
                        },
                    }}
                >
                    <Box
                        className="tw-flex tw-items-center tw-gap-4 tw-bg-gtr-sidebar tw-px-5 tw-py-4 tw-text-white"
                        sx={{
                            display: "flex",
                            flexShrink: 0,
                            alignItems: "center",
                            gap: 2,
                            paddingX: { xs: 2, sm: 3 },
                            paddingY: 2,
                            color: "#ffff",
                            backgroundImage: "linear-gradient(to right, #006C77, #09414A)",
                        }}
                    >
                        <Box className="tw-flex tw-min-w-0 tw-items-center tw-gap-4">
                            <Box
                                className="tw-flex tw-h-14 tw-w-14 tw-flex-none tw-items-center tw-justify-center tw-rounded-xl tw-bg-white/10"
                                sx={{ width: 56, height: 56, flexShrink: 0, borderRadius: 3, backgroundColor: "rgba(255,255,255,0.10)" }}
                            >
                                <SettingsOutlined sx={{ fontSize: 30 }} />
                            </Box>
                            <Box sx={{ minWidth: 0 }}>
                                <Typography id="report-filter-dialog-title" sx={{ color: "inherit", fontFamily: "Prometo", fontSize: { xs: 18, sm: 21 }, fontWeight: 700 }}>
                                    {selectedReport.name || "Configurar relatório"}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box
                        className="report-filter-body row"
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            alignContent: "flex-start",
                            width: "100%",
                            overflowY: "auto",
                            margin: 0,
                            padding: { xs: 2, sm: 3 },
                            backgroundColor: "#ffff",
                            scrollbarWidth: "thin",
                            scrollbarColor: "#006C77 transparent",
                        }}
                    >
                        {!loading && (
                            <>
                                {/* Abas do Diário de Bordo */}
                                {hasDeviceHistoryFilter && (
                                    <Box className="col-sm-12 col-md-12" style={{ marginBottom: 10 }}>
                                        <Tabs
                                            value={logbookTabValue}
                                            onChange={(_, v) => {
                                                setLogbookTabValue(v);
                                                setSelectedHistoryVehicle(null);
                                                setSelectedHistoryDevice(null);
                                                setDeviceHistorySearch("");
                                                if (v === 0) {
                                                    setShowActiveVehicles(true);
                                                }
                                            }}
                                            variant="standard"
                                            indicatorColor="primary"
                                            textColor="inherit"
                                            sx={{ fontSize: "14px", fontFamily: "Prometo", background: "#f3f4f6", borderRadius: 1 }}
                                        >
                                            <Tab label="Vigente" value={0} />
                                            {getCurrentUser.accessProfile.id !== Number(PROFILE_ACESSES.DRIVER) && (
                                                <Tab label="Histórico de Dispositivos" value={1} />
                                            )}
                                        </Tabs>
                                    </Box>
                                )}

                                <>{(getCurrentUser.configs.isManager && uppertTabValue === 5) &&
                                    <>
                                        <Box className={(selectedReport.id >= 17 && selectedReport.id <= 28) ? "col-md-10" : "col-md-12"} style={{ marginBottom: 20 }}>
                                            <Autocomplete
                                                id="chip-label-select-customer"
                                                className="input-select-customer"
                                                style={{
                                                    width: "100%",
                                                    minHeight: "56px",
                                                    height: "56px",
                                                    backgroundColor: "#ffffff29",
                                                    borderColor: "lightgray",
                                                }}
                                                options={customersList}
                                                value={customer}
                                                onChange={(_, option) => {
                                                    setCustomer(option ?? customerDefault);
                                                }}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                disabled={!getCurrentUser.configs.isManager}
                                                getOptionLabel={(option) => `${option.reducedName}`}
                                                noOptionsText={"Nada encontrado"}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Cliente"
                                                        placeholder="Selecione um cliente"
                                                        autoComplete="off"
                                                        required
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={reportFilterFieldSx}
                                                    />
                                                )}
                                            />
                                        </Box>

                                        {(selectedReport.id >= 17 && selectedReport.id <= 28) && (
                                            <Box
                                                className="col-md-2"
                                                style={{ margin: "0px 0px 20px 0px" }}
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            disabled={false}
                                                            checked={isViewingAll}
                                                            onChange={(event) => {
                                                                setIsViewingAll(event.target.checked);
                                                            }}
                                                        />
                                                    }
                                                    label="Geral"
                                                />

                                                <Tooltip
                                                    title={
                                                        "Marque essa opção para exportar o relatório geral do cliente."
                                                    }
                                                    arrow
                                                >
                                                    <InfoOutlined className="report-info-icon" sx={{ marginLeft: 0.5, cursor: "pointer" }} />
                                                </Tooltip>
                                            </Box>
                                        )}

                                        {![30, INTEREST_POINTS_REPORT_ID, INTEREST_POINTS_NEAR_VEHICLE_REPORT_ID].includes(selectedReport.id) && <><Box className="col-md-6" style={{ marginBottom: 10 }}>
                                            <Autocomplete
                                                id="chip-label-select-secretary"
                                                className="input-select-secretary"
                                                style={{
                                                    width: "100%",
                                                    minHeight: "56px",
                                                    height: "56px",
                                                    backgroundColor: "#ffffff29",
                                                    borderColor: "lightgray",
                                                }}
                                                options={secretariesList}
                                                value={secretary}
                                                onChange={(_, option) => {
                                                    setSecretary(option ?? secretaryDefault);
                                                }}
                                                disabled={!getCurrentUser.configs.isManager || isViewingAll}
                                                getOptionLabel={(option) => `${option.reducedName}`}
                                                noOptionsText={"Nada encontrado"}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Secretaria"
                                                        placeholder="Selecione uma secretaria"
                                                        autoComplete="off"
                                                        required={selectedReport.id !== 34}
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={reportFilterFieldSx}
                                                    />
                                                )}
                                            />
                                        </Box>

                                            <Box className="col-md-6" style={{ marginBottom: 10 }}>
                                                <Autocomplete
                                                    id="chip-label-select-department"
                                                    className="input-select-department"
                                                    style={{
                                                        width: "100%",
                                                        minHeight: "56px",
                                                        height: "56px",
                                                        backgroundColor: "#ffffff29",
                                                        borderColor: "lightgray",
                                                    }}
                                                    options={departmentsList}
                                                    value={department}
                                                    onChange={(_, option) => {
                                                        setDepartment(option ?? departmentDefault);
                                                    }}
                                                    disabled={!getCurrentUser.configs.isManager || isViewingAll}
                                                    getOptionLabel={(option) => `${option.reducedName}`}
                                                    noOptionsText={"Nada encontrado"}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Departamento"
                                                            placeholder="Selecione um departamento"
                                                            required={selectedReport.id !== 34}
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={reportFilterFieldSx}
                                                        />
                                                    )}
                                                />
                                            </Box></>}
                                    </>
                                }</>

                                {/* ===== ABA HISTÓRICO DE DISPOSITIVOS (Diário de Bordo) ===== */}
                                {isDeviceHistoryMode && (
                                    <Box className="col-sm-12 col-md-12 tw-grid tw-min-w-0 tw-gap-3" sx={{ gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "minmax(0, 1fr) auto" } }}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, minHeight: 56, gridColumn: { sm: ![29, 30].includes(selectedReport.id) ? 2 : 1 }, gridRow: { sm: 1 } }}>
                                            <Typography sx={{ fontFamily: "Prometo", fontSize: "14px", color: !showActiveVehicles ? "#0FB403" : "#999" }}>Inativos</Typography>
                                            <Switch
                                                checked={showActiveVehicles}
                                                onChange={(e) => {
                                                    setShowActiveVehicles(e.target.checked);
                                                    setSelectedHistoryVehicle(null);
                                                    setSelectedHistoryDevice(null);
                                                    setDeviceHistorySearch("");
                                                }}
                                                sx={{
                                                    width: 42, height: 26, padding: 0,
                                                    '& .MuiSwitch-switchBase': {
                                                        padding: 0, margin: '2px',
                                                        transitionDuration: '300ms',
                                                        '&.Mui-checked': {
                                                            transform: 'translateX(16px)',
                                                            color: '#fff',
                                                            '& + .MuiSwitch-track': { backgroundColor: '#65C466', opacity: 1, border: 0 },
                                                        },
                                                    },
                                                    '& .MuiSwitch-thumb': { boxSizing: 'border-box', width: 22, height: 22 },
                                                    '& .MuiSwitch-track': { borderRadius: 13, backgroundColor: '#E9E9EA', opacity: 1 },
                                                }}
                                            />
                                            <Typography sx={{ fontFamily: "Prometo", fontSize: "14px", color: showActiveVehicles ? "#0FB403" : "#999" }}>Ativos</Typography>
                                        </Box>

                                        {![29, 30].includes(selectedReport.id) && (
                                            <Box sx={{ minWidth: 0, gridColumn: 1, gridRow: { sm: 1 } }}>
                                                <Autocomplete
                                                    id="logbook-vehicle-select"
                                                    style={{
                                                        width: "100%",
                                                        minHeight: "56px",
                                                        height: "56px",
                                                        backgroundColor: "#ffffff29",
                                                        borderColor: "lightgray",
                                                        fontFamily: "Prometo",
                                                    }}
                                                    options={vehicleList}
                                                    value={selectedHistoryVehicle}
                                                    onChange={(_, option) => {
                                                        setSelectedHistoryVehicle(option);
                                                        setSelectedHistoryDevice(null);
                                                        setDeviceHistorySearch("");
                                                    }}
                                                    getOptionLabel={(option) =>
                                                        `${option?.name} - ${option?.vehiclePlate} (${option?.deviceImei ?? option?.satelliteImei ?? "Sem dispositivo"})`
                                                    }
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    noOptionsText={"Nenhum veículo encontrado"}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Veículo"
                                                            placeholder="Selecione um veículo"
                                                            required
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={reportFilterFieldSx}
                                                        />
                                                    )}
                                                />
                                            </Box>
                                        )}

                                        {selectedHistoryVehicle && (
                                            <Box className="report-device-history-panel" sx={{ minWidth: 0, gridColumn: "1 / -1", mb: 1 }}>
                                                <Box className="tw-grid tw-items-center tw-gap-3" sx={{ gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "minmax(0, 1fr) minmax(220px, 0.9fr)" }, mb: 1.5 }}>
                                                    <Typography variant="subtitle2" sx={{ minWidth: 0, overflowWrap: "anywhere", fontWeight: 700, fontFamily: "Prometo", color: "#263238" }}>
                                                        Histórico de Dispositivos — {selectedHistoryVehicle.name}
                                                    </Typography>
                                                    <TextField
                                                        label="Pesquisar dispositivo"
                                                        placeholder="Digite o IMEI"
                                                        value={deviceHistorySearch}
                                                        onChange={(e) => setDeviceHistorySearch(e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={reportFilterFieldSx}
                                                        InputProps={{
                                                            startAdornment: <SearchOutlined sx={{ fontSize: 18, mr: 0.5, color: "#666" }} />,
                                                            endAdornment: deviceHistorySearch && (
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => setDeviceHistorySearch("")}
                                                                    sx={{ padding: 0 }}
                                                                >
                                                                    <CloseOutlined sx={{ fontSize: 16 }} />
                                                                </IconButton>
                                                            )
                                                        }}
                                                    />
                                                </Box>
                                                {selectedHistoryVehicle.deviceHistory && selectedHistoryVehicle.deviceHistory.length > 0 ? (
                                                    <Box
                                                        className="report-device-history-list"
                                                        role="radiogroup"
                                                        aria-label="Histórico de dispositivos do veículo"
                                                        sx={{
                                                        width: "100%",
                                                        maxWidth: "100%",
                                                        maxHeight: "clamp(220px, 40dvh, 420px)",
                                                        overflowY: "auto",
                                                        overflowX: "hidden",
                                                        overscrollBehaviorY: "contain",
                                                        border: "none",
                                                        borderRadius: 2,
                                                        backgroundColor: "#fff",
                                                        scrollbarWidth: "thin",
                                                        scrollbarColor: "#c1c1c1 transparent",
                                                        "&::-webkit-scrollbar": { width: "5px" },
                                                        "&::-webkit-scrollbar-track": { background: "transparent" },
                                                        "&::-webkit-scrollbar-thumb": { backgroundColor: "#c1c1c1", borderRadius: "10px" },
                                                        "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#9e9e9e" },
                                                    }}>
                                                                {(() => {
                                                                    const filtered = selectedHistoryVehicle.deviceHistory
                                                                        ?.filter((device: any) =>
                                                                            !deviceHistorySearch ||
                                                                            device.deviceImei?.toLowerCase().includes(deviceHistorySearch.toLowerCase())
                                                                        );

                                                                    if (filtered.length === 0) {
                                                                        return (
                                                                            <Typography sx={{ py: 4, px: 2, textAlign: "center", color: "#666", fontFamily: "Prometo", fontStyle: "italic" }}>
                                                                                Nenhum dado encontrado
                                                                            </Typography>
                                                                        );
                                                                    }

                                                                    return filtered.map((device: any, idx: number) => (
                                                                        <Box
                                                                            className="report-device-history-item"
                                                                            key={device.id || idx}
                                                                            role="radio"
                                                                            aria-checked={selectedHistoryDevice?.id === device.id}
                                                                            tabIndex={0}
                                                                            onClick={() => setSelectedHistoryDevice(device)}
                                                                            onKeyDown={(event) => {
                                                                                if (event.key === "Enter" || event.key === " ") {
                                                                                    event.preventDefault();
                                                                                    setSelectedHistoryDevice(device);
                                                                                }
                                                                            }}
                                                                            sx={{
                                                                                cursor: "pointer",
                                                                                display: "grid",
                                                                                gridTemplateColumns: "28px minmax(0, 1fr)",
                                                                                gap: 1,
                                                                                px: { xs: 1, sm: 1.5 },
                                                                                py: 1,
                                                                                borderBottom: idx < filtered.length - 1 ? "1px solid rgba(0, 63, 74, 0.10)" : "none",
                                                                                backgroundColor: selectedHistoryDevice?.id === device.id ? "#e8f5e9" : "#fff",
                                                                                animation: 'fadeIn 0.3s ease-out forwards',
                                                                                opacity: 0,
                                                                                '@keyframes fadeIn': {
                                                                                    '0%': { opacity: 0, transform: 'translateY(8px)' },
                                                                                    '100%': { opacity: 1, transform: 'translateY(0)' },
                                                                                },
                                                                                transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
                                                                                "&:hover": { backgroundColor: selectedHistoryDevice?.id === device.id ? "#e8f5e9" : "rgba(0, 108, 119, 0.05)" },
                                                                                "&:focus-visible": { outline: "2px solid #00B700", outlineOffset: -2 },
                                                                            }}
                                                                        >
                                                                            <Radio
                                                                                checked={selectedHistoryDevice?.id === device.id}
                                                                                size="small"
                                                                                inputProps={{ "aria-label": `Selecionar dispositivo ${device.deviceImei ?? "sem IMEI"}` }}
                                                                                sx={{ p: 0.5, alignSelf: "start", color: "#006C77", '&.Mui-checked': { color: "#00B700" } }}
                                                                            />
                                                                            <Box className="tw-grid tw-min-w-0 tw-items-start tw-gap-x-3 tw-gap-y-2" sx={{
                                                                                gridTemplateColumns: {
                                                                                    xs: "repeat(2, minmax(0, 1fr))",
                                                                                    md: getCurrentUser.accessProfile.id === Number(PROFILE_ACESSES.ADMIN)
                                                                                        ? "minmax(0, 1.25fr) 96px 96px minmax(0, 1.15fr) minmax(0, 0.85fr)"
                                                                                        : "minmax(0, 1.25fr) 96px 96px minmax(0, 1.5fr)",
                                                                                },
                                                                                "& .MuiTypography-root": { overflowWrap: "anywhere" },
                                                                            }}>
                                                                                <Box className="tw-flex tw-min-w-0 tw-flex-col tw-items-start tw-gap-1" sx={{ gridColumn: { xs: "1 / -1", md: "auto" } }}>
                                                                                    <Typography sx={{ minWidth: 0, fontFamily: "Prometo", fontSize: "13px", fontWeight: 700, color: "#263238", overflowWrap: "anywhere" }}>
                                                                                        IMEI: {device.deviceImei ?? "—"}
                                                                                    </Typography>
                                                                                    <Chip
                                                                                        size="small"
                                                                                        label={device.type || "—"}
                                                                                        icon={<DeviceHubOutlined style={{ fontSize: 14 }} />}
                                                                                        sx={{ maxWidth: "100%", height: "auto", minHeight: 22, fontFamily: "Prometo", fontSize: "11px", "& .MuiChip-label": { whiteSpace: "normal", overflowWrap: "anywhere", py: 0.25 } }}
                                                                                    />
                                                                                </Box>
                                                                                <Box className="tw-contents">
                                                                                    <Box sx={{ minWidth: 0 }}>
                                                                                        <Typography sx={{ fontFamily: "Prometo", fontSize: "11px", color: "#607d80", mb: 0.35 }}>Status do vínculo</Typography>
                                                                                        <Chip
                                                                                            size="small"
                                                                                            label={device.activated ? "Ativo" : "Removido"}
                                                                                            icon={<CheckCircleOutlineOutlined style={{ fontSize: 14, color: device.activated ? "#0FB403" : "#dc3545" }} />}
                                                                                            sx={{ height: 24, fontFamily: "Prometo", fontSize: "11px", color: device.activated ? "#0FB403" : "#dc3545", borderColor: device.activated ? "#0FB403" : "#dc3545" }}
                                                                                            variant="outlined"
                                                                                        />
                                                                                    </Box>
                                                                                    <Box sx={{ minWidth: 0 }}>
                                                                                        <Typography sx={{ fontFamily: "Prometo", fontSize: "11px", color: "#607d80", mb: 0.35 }}>Status do dispositivo</Typography>
                                                                                        <Chip
                                                                                            size="small"
                                                                                            label={device.deviceActivated ? "Ativo" : "Inativo"}
                                                                                            icon={<CheckCircleOutlineOutlined style={{ fontSize: 14, color: device.deviceActivated ? "#0FB403" : "#dc3545" }} />}
                                                                                            sx={{ height: 24, fontFamily: "Prometo", fontSize: "11px", color: device.deviceActivated ? "#0FB403" : "#dc3545", borderColor: device.deviceActivated ? "#0FB403" : "#dc3545" }}
                                                                                            variant="outlined"
                                                                                        />
                                                                                    </Box>
                                                                                    <Box sx={{ minWidth: 0, gridColumn: { xs: "1 / -1", md: "auto" } }}>
                                                                                        <Typography sx={{ fontFamily: "Prometo", fontSize: "11px", color: "#607d80" }}>Período do vínculo</Typography>
                                                                                        <Typography sx={{ fontFamily: "Prometo", fontSize: "12px", color: "#7a5600", lineHeight: 1.45 }}>
                                                                                            {device.createdAt ? dayjs(device.createdAt).format("DD/MM/YYYY HH:mm") : "—"} até {device.updatedAt ? dayjs(device.updatedAt).format("DD/MM/YYYY HH:mm") : "—"}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                    {getCurrentUser.accessProfile.id === Number(PROFILE_ACESSES.ADMIN) && (
                                                                                        <Box sx={{ minWidth: 0, gridColumn: { xs: "1 / -1", md: "auto" } }}>
                                                                                            <Typography sx={{ fontFamily: "Prometo", fontSize: "11px", color: "#607d80" }}>Última posição</Typography>
                                                                                            <Typography sx={{ fontFamily: "Prometo", fontSize: "12px", color: "#7a5600", lineHeight: 1.45 }}>
                                                                                                {device.deviceLastUpdate ? dayjs(device.deviceLastUpdate).format("DD/MM/YYYY HH:mm") : "—"}
                                                                                            </Typography>
                                                                                        </Box>
                                                                                    )}
                                                                                </Box>
                                                                            </Box>
                                                                        </Box>
                                                                    ));
                                                                })()}
                                                    </Box>
                                                ) : (
                                                    <Box className="report-device-history-empty" sx={{ p: 2, textAlign: "center", background: "#f9f9f9", borderRadius: 1, border: "none" }}>
                                                        <Typography sx={{ fontFamily: "Prometo", fontSize: "13px", color: "#999" }}>
                                                            Nenhum histórico de dispositivo encontrado para este veículo.
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Box>
                                        )}

                                        {selectedHistoryDevice && (
                                            <Box sx={{ minWidth: 0, gridColumn: "1 / -1", mb: 1 }}>
                                                <Chip
                                                    size="small"
                                                    label={`Dispositivo selecionado: ${selectedHistoryDevice.deviceImei}`}
                                                    sx={{ width: "100%", height: "auto", justifyContent: "flex-start", fontFamily: "Prometo", fontSize: "12px", background: "#e8f5e9", color: "#333", "& .MuiChip-label": { py: 0.75, whiteSpace: "normal", overflowWrap: "anywhere" } }}
                                                />
                                            </Box>
                                        )}
                                    </Box>
                                )}

                                {!isDeviceHistoryMode && ((![2, 5, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 34, INTEREST_POINTS_REPORT_ID, INTEREST_POINTS_NEAR_VEHICLE_REPORT_ID].includes(
                                    selectedReport.id
                                ) &&
                                    reportType === "common") ||
                                    (reportType === "map" && selectedReport.id !== INTEREST_POINTS_NEAR_VEHICLE_REPORT_ID)) &&
                                    !(getCurrentUser.accessProfile.id === Number(PROFILE_ACESSES.DRIVER) && [4, 5].includes(selectedReport.id)) && (
                                        <Box
                                            className="col-md-12"
                                            style={{ margin: "10px 0px 10px 0px" }}
                                        >
                                            <Autocomplete
                                                id="chip-label-select-vehicle"
                                                className="input-select-vehicle"
                                                disabled={selectedDrivers.length > 0}
                                                style={{
                                                    width: "100%",
                                                    minHeight: "56px",
                                                    height: groupVehicles.length === 0 ? "56px" : "auto",
                                                    backgroundColor: "#ffffff29",
                                                    borderColor: "lightgray",
                                                    fontFamily: "Prometo",
                                                }}
                                                multiple
                                                limitTags={2}
                                                groupBy={(option) => option.vehicleTypeName}
                                                options={vehicleList.sort(
                                                    (a, b) => -b?.vehicleTypeName.localeCompare(a?.vehicleTypeName)
                                                )}
                                                value={vehicleList.filter((a) =>
                                                    groupVehicles.includes(String(a.id))
                                                )}
                                                onChange={(_, value) => {
                                                    setGroupVehicles(
                                                        value.map((a) => String(a.id)).slice(0, 1)
                                                    );
                                                }}
                                                getOptionLabel={(option) =>
                                                    `${option?.name} - ${option?.vehiclePlate}(${option?.deviceImei ?? option?.satelliteImei ?? "Sem dispositivo"})`
                                                }
                                                noOptionsText={"Nada encontrado"}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Veículo"
                                                        placeholder="Selecione um veículo"
                                                        required={selectedDrivers.length === 0}
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={reportFilterFieldSx}
                                                    />
                                                )}
                                            />
                                        </Box>
                                    )}

                                {!isDeviceHistoryMode && ([4, 9, 29, 34].includes(
                                    selectedReport.id
                                ) &&
                                    ((reportType === "common") ||
                                        reportType === "map")) && (
                                        <Box
                                            className="col-md-12"
                                            style={{ margin: "10px 0px 10px 0px" }}
                                        >
                                            <Autocomplete
                                                id="chip-label-select-driver"
                                                className="input-select-driver"
                                                disabled={groupVehicles.length > 0}
                                                style={{
                                                    width: "100%",
                                                    minHeight: "56px",
                                                    height: groupVehicles.length === 0 ? "56px" : "auto",
                                                    backgroundColor: "#ffffff29",
                                                    borderColor: "lightgray",
                                                    fontFamily: "Prometo",
                                                }}
                                                multiple
                                                limitTags={2}
                                                options={driversList}
                                                value={driversList.filter((a) =>
                                                    selectedDrivers.includes(String(a.driverIdentifier))
                                                )}
                                                onChange={(_, value) => {
                                                    setSelectedDrivers(
                                                        value.map((a) => String(a.driverIdentifier)).slice(0, 1)
                                                    );
                                                }}
                                                getOptionLabel={(option) =>
                                                    `${option.name} - ${option.driverCode}(${option.driverIdentifier})`
                                                }
                                                noOptionsText={"Nada encontrado"}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Motorista"
                                                        placeholder="Selecione um motorista"
                                                        required={selectedReport.id !== 34 && groupVehicles.length === 0}
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={reportFilterFieldSx}
                                                    />
                                                )}
                                            />
                                        </Box>
                                    )}

                                {[2, 5].includes(selectedReport.id) &&
                                    reportType === "common" && (
                                        <Box
                                            className="col-md-12"
                                            style={{ margin: "10px 0px 10px 0px" }}
                                        >
                                            <Autocomplete
                                                id="chip-label-select-group"
                                                className="input-select-group"
                                                style={{
                                                    width: "100%",
                                                    minHeight: "56px",
                                                    height: groupVehicles.length === 0 ? "56px" : "auto",
                                                    backgroundColor: "#ffffff29",
                                                    borderColor: "lightgray",
                                                }}
                                                multiple
                                                limitTags={2}
                                                options={groupsList}
                                                value={groupsList.filter((a) =>
                                                    selectedGroupsList.includes(String(a.id))
                                                )}
                                                onChange={(_, value) => {
                                                    setSelectedGroupList(
                                                        value.map((a) => String(a.id)).slice(0, 1)
                                                    );
                                                }}
                                                getOptionLabel={(option) => `${option.name}`}
                                                noOptionsText={"Nada encontrado"}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Grupos"
                                                        placeholder="Selecione um grupo"
                                                        required
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={reportFilterFieldSx}
                                                    />
                                                )}
                                            />
                                        </Box>
                                    )}

                                {(([1, 2, 5, 30, INTEREST_POINTS_REPORT_ID].includes(selectedReport.id) &&
                                    reportType !== "map") ||
                                    (selectedReport.id >= 17 && selectedReport.id <= 28)) && (
                                        <>
                                            <Box
                                                className="col-md-12"
                                                style={{ margin: "5px 0px 5px 0px" }}
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            disabled={false}
                                                            checked={onlyActives}
                                                            onChange={(event) => {
                                                                setOnlyActives(event.target.checked);
                                                                setOnlyInactives(false);
                                                            }}
                                                        />
                                                    }
                                                    label="Apenas ativos"
                                                />

                                                <Tooltip
                                                    title={
                                                        "Marque essa opção para exportar apenas os veículos ativos."
                                                    }
                                                    arrow
                                                >
                                                    <InfoOutlined className="report-info-icon" sx={{ margin: 0.5, cursor: "pointer" }} />
                                                </Tooltip>
                                            </Box>

                                            <Box
                                                className="col-md-12"
                                                style={{ margin: "5px 0px 5px 0px" }}
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            disabled={false}
                                                            checked={onlyInactives}
                                                            onChange={(event) => {
                                                                setOnlyInactives(event.target.checked);
                                                                setOnlyActives(false);
                                                            }}
                                                        />
                                                    }
                                                    label="Apenas inativos"
                                                />

                                                <Tooltip
                                                    title={
                                                        "Marque essa opção para exportar apenas os veículos inativos."
                                                    }
                                                    arrow
                                                >
                                                    <InfoOutlined className="report-info-icon" sx={{ margin: 0.5, cursor: "pointer" }} />
                                                </Tooltip>
                                            </Box>
                                        </>
                                    )}

                                {(selectedReport.id === 3 && reportType === "map") && (
                                    <>
                                        {addresses.map((address, index) => {
                                            const isOrigin = index === 0;
                                            const isDestination = index === addresses.length - 1;
                                            const label = isOrigin ? "Ponto Inicial" : isDestination ? "Ponto Final" : `Parada ${index}`;

                                            return (
                                                <Box className="col-md-12" style={{ margin: "10px 0px 10px 0px", display: "flex", alignItems: "center", gap: 8 }} key={index}>
                                                    <Box sx={{ flex: 1 }}>
                                                        <Autocomplete
                                                            freeSolo
                                                            loading={!!addressLoadingMap[index]}
                                                            inputValue={address.query ?? ""}
                                                            options={(address.predictionResults ?? []).map((option) => option.display_name)}
                                                            onInputChange={handleAddressInputChange(index)}
                                                            onChange={handleAddressSelect(index)}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label={label}
                                                                    placeholder={isOrigin ? "Digite o endereço de partida" : isDestination ? "Digite o endereço de destino" : "Digite o endereço da parada"}
                                                                    variant="outlined"
                                                                    InputLabelProps={{ shrink: true }}
                                                                    sx={reportFilterFieldSx}
                                                                />
                                                            )}
                                                        />
                                                    </Box>
                                                    {!isOrigin && !isDestination && (
                                                        <Tooltip title="Remover parada" arrow placement="top">
                                                            <IconButton aria-label="Remover parada" size="small" onClick={() => removeStop(index)}>
                                                                <CloseOutlined sx={{ fontSize: 18, color: '#dc3545' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                </Box>
                                            );
                                        })}

                                        <Box className="col-md-12" style={{ margin: "10px 0px 10px 0px" }}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                onClick={addStop}
                                                disabled={addresses.length >= MAX_STOPS}
                                                sx={{
                                                    fontFamily: "Prometo",
                                                    borderColor: '#0FB403',
                                                    color: '#0FB403',
                                                    '&:hover': { borderColor: '#087002', background: '#e8f5e9' },
                                                }}
                                            >
                                                + Adicionar parada
                                            </Button>
                                        </Box>
                                    </>
                                )}

                                {selectedReport.id === INTEREST_POINTS_NEAR_VEHICLE_REPORT_ID && (
                                    <>
                                        <Box className="col-md-8" style={{ margin: "10px 0px 10px 0px" }}>
                                            <Autocomplete
                                                id="near-vehicle-select"
                                                options={vehicleList}
                                                value={nearVehicleSelected}
                                                onChange={(_, option) => {
                                                    setNearVehicleSelected(option);
                                                }}
                                                getOptionLabel={(option) =>
                                                    `${option?.name} - ${option?.vehiclePlate}`
                                                }
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                noOptionsText={"Nenhum veículo encontrado"}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Veículo"
                                                        placeholder="Selecione um veículo"
                                                        required
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={reportFilterFieldSx}
                                                    />
                                                )}
                                            />
                                        </Box>

                                        <Box className="col-md-4" style={{ margin: "10px 0px 10px 0px" }}>
                                            <TextField
                                                id="near-vehicle-max-distance"
                                                type="number"
                                                label="Distância máxima (km)"
                                                placeholder="Sem limite"
                                                fullWidth
                                                value={maxDistanceKm}
                                                onChange={(e) => setMaxDistanceKm(e.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ min: 0, step: 0.1 }}
                                                sx={reportFilterFieldSx}
                                            />
                                        </Box>
                                    </>
                                )}

                                {((![1, 2, 5, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 30, 32, 34, INTEREST_POINTS_REPORT_ID, INTEREST_POINTS_NEAR_VEHICLE_REPORT_ID].includes(
                                    selectedReport.id
                                ) &&
                                    reportType === "common") ||
                                    (reportType === "map" && selectedReport.id !== INTEREST_POINTS_NEAR_VEHICLE_REPORT_ID)) && (
                                        <>
                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "10px 0px 10px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{
                                                        width: "100%"
                                                    }}
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterDayjs}
                                                        adapterLocale={"pt-br"}
                                                    >
                                                        <MobileDateTimePicker
                                                            sx={reportFilterFieldSx}
                                                            label={"Data início"}
                                                            format="DD/MM/YYYY HH:mm:ss"
                                                            timezone={reportTimezone}
                                                            slotProps={{
                                                                textField: {
                                                                    placeholder: "Selecione a data e hora inicial",
                                                                    InputLabelProps: { shrink: true },
                                                                },
                                                            }}
                                                            onChange={(value) => {
                                                                setStartDate(value);
                                                            }}
                                                            value={startDate ?? defaultReportStartDate}
                                                            minDateTime={defaultReportStartDate.subtract(5, "years")}
                                                            maxDateTime={dayjs().tz(reportTimezone)}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Box>
                                            <Box
                                                className="col-md-6"
                                                style={{ margin: "10px 0px 10px 0px" }}
                                            >
                                                <FormControl
                                                    className="form-group"
                                                    style={{
                                                        width: "100%"
                                                    }}
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={AdapterDayjs}
                                                        adapterLocale={"pt-br"}
                                                    >
                                                        <MobileDateTimePicker
                                                            sx={reportFilterFieldSx}
                                                            label={"Data final"}
                                                            format="DD/MM/YYYY HH:mm:ss"
                                                            timezone={reportTimezone}
                                                            slotProps={{
                                                                textField: {
                                                                    placeholder: "Selecione a data e hora final",
                                                                    InputLabelProps: { shrink: true },
                                                                },
                                                            }}
                                                            onChange={(value) => {
                                                                setEndDate(value);
                                                            }}
                                                            value={endDate ?? defaultReportEndDate}
                                                            minDateTime={startDate ?? defaultReportStartDate}
                                                            maxDateTime={defaultReportEndDate}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Box>
                                        </>
                                    )}

                                {reportType === "common"
                                    && ([3, 4, 6, 7, 8, 9, 15].includes(selectedReport.id)
                                        || VEHICLE_OPERATIONAL_REPORT_IDS.includes(selectedReport.id))
                                    && <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={repeatHeader}
                                                onChange={(event) => {
                                                    setRepeatHeader(event.target.checked);
                                                }}
                                            />
                                        }
                                        label="Repetir cabeçalho"
                                    />}
                            </>
                        )}
                    </Box>
                    <Box
                        className="report-filter-footer tw-flex tw-flex-col-reverse tw-gap-2 tw-border-t tw-border-black/10 tw-bg-white/70 tw-p-4 sm:tw-flex-row sm:tw-justify-end"
                        sx={{
                            width: "100%",
                            flexShrink: 0,
                            display: "flex",
                            flexDirection: { xs: "column-reverse", sm: "row" },
                            justifyContent: { sm: "flex-end" },
                            gap: 1,
                            padding: 2,
                            borderTop: "1px solid rgba(0,0,0,0.10)",
                            backgroundColor: "#ffff",
                        }}
                    >
                            <Button
                                type="button"
                                variant="contained"
                                startIcon={<CloseOutlined />}
                                onClick={() => {
                                    if (!isToastVisible) {
                                        handleClose();
                                    }
                                }}
                                sx={{
                                    minWidth: 132,
                                    minHeight: 44,
                                    borderRadius: 2,
                                    color: "#ffff",
                                    backgroundColor: "#dc3545",
                                    fontFamily: "Prometo",
                                    textTransform: "none",
                                    boxShadow: "none",
                                    transition: "transform 200ms ease, box-shadow 200ms ease",
                                    "&:hover": {
                                        backgroundColor: "#dc3545",
                                        boxShadow: "0 8px 18px rgba(220,53,69,0.22)",
                                        transform: "translateY(-1px)",
                                    },
                                }}
                            >
                                Fechar
                            </Button>

                            <Button
                                type="button"
                                variant="contained"
                                startIcon={reportType === "common" ? <PrintOutlined /> : <VisibilityOutlined />}
                                ref={(ref) => (anchorRef.current = ref)}
                                onClick={(e) => {
                                    anchorRef.current = e.currentTarget;
                                    if (isDeviceHistoryMode) {
                                        if (selectedHistoryVehicle && selectedHistoryDevice) {
                                            setGroupVehicles([String(selectedHistoryVehicle.id)]);
                                            if (reportType === "map") {
                                                setTimeout(() => getReportMap(), 100);
                                            } else {
                                                setTimeout(() => setOpen(true), 100);
                                            }
                                        }
                                    } else {
                                        (reportType === "map" && selectedReport.id !== INTEREST_POINTS_NEAR_VEHICLE_REPORT_ID) ? getReportMap() : setOpen(true);
                                    }
                                }}
                                disabled={
                                    (isDeviceHistoryMode &&
                                        (!selectedHistoryVehicle || !selectedHistoryDevice)) ||
                                    (VEHICLE_OPERATIONAL_REPORT_IDS.includes(selectedReport.id) &&
                                        groupVehicles.length !== 1) ||
                                    (selectedReport.id === INTEREST_POINTS_NEAR_VEHICLE_REPORT_ID && !nearVehicleSelected)
                                }
                                sx={{
                                    minWidth: 132,
                                    minHeight: 44,
                                    borderRadius: 2,
                                    color: "#ffff",
                                    backgroundColor: "#00B700",
                                    fontFamily: "Prometo",
                                    textTransform: "none",
                                    boxShadow: "none",
                                    transition: "transform 200ms ease, box-shadow 200ms ease",
                                    "&:hover": {
                                        backgroundColor: "#00B700",
                                        boxShadow: "0 8px 18px rgba(0,183,0,0.22)",
                                        transform: "translateY(-1px)",
                                    },
                                    "&.Mui-disabled": { backgroundColor: "#cbd5e1", color: "#ffffff" },
                                }}
                            >
                                {(reportType === "common" || selectedReport.id === INTEREST_POINTS_NEAR_VEHICLE_REPORT_ID) ? "Imprimir" : "Abrir mapa"}
                            </Button>
                            <Menu
                                open={open}
                                anchorEl={() => anchorRef.current as HTMLElement}
                                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                                transformOrigin={{ vertical: "bottom", horizontal: "center" }}
                                onClose={() => {
                                    setOpen(false);
                                }}
                                sx={{ zIndex: 1300 }}
                            >
                                {((selectedReport.id >= 17 && selectedReport.id <= 28) ||
                                    VEHICLE_OPERATIONAL_REPORT_IDS.includes(selectedReport.id)
                                    ? items
                                    : items.slice(0, 2)).map((option: MenuIt, index) => (
                                    <MenuItem
                                        style={{ width: 160 }}
                                        key={option?.id}
                                        onClick={(e: any) => {
                                            setOpen(false);
                                            getReport(option.label!!.toLocaleLowerCase());
                                        }}
                                    >
                                        {` ${option.label}`}
                                    </MenuItem>
                                ))}
                            </Menu>
                    </Box>
                </Paper>
            </Rmodal >
        );
    }, [
        defaultReportEndDate,
        defaultReportStartDate,
        reportTimezone,
        selectedReport.id,
        selectedReport.name,
        startDate,
        endDate,
        isOpenDetails,
        loading,
        logbookTabValue,
        hasDeviceHistoryFilter,
        isDeviceHistoryMode,
        getCurrentUser.accessProfile.id,
        getCurrentUser.configs.isManager,
        uppertTabValue,
        customersList,
        customer,
        isViewingAll,
        secretariesList,
        secretary,
        departmentsList,
        department,
        showActiveVehicles,
        vehicleList,
        selectedHistoryVehicle,
        deviceHistorySearch,
        selectedHistoryDevice,
        reportType,
        selectedDrivers,
        groupVehicles,
        driversList,
        groupsList,
        selectedGroupsList,
        onlyActives,
        onlyInactives,
        addresses,
        addStop,
        repeatHeader,
        open,
        validationText,
        addressLoadingMap,
        handleAddressInputChange,
        handleAddressSelect,
        removeStop,
        isToastVisible,
        handleClose,
        getReportMap,
        getReport
    ]);

    return (
        <>
            {!isOpenReportMap && DetailsModal}
            {isOpenReportMap && RenderMapModal}
            {isOpenRoutesReport && <Rmodal open={isOpenRoutesReport} handleClose={() => setIsOpenRoutesReport(false)}>
                <Paper elevation={0} role="dialog" aria-labelledby="routes-report-filter-title" className="parameters-container tw-overflow-hidden tw-rounded-2xl tw-shadow-2xl tw-transition-all tw-duration-300 tw-ease-gtr-smooth" sx={{
                    position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
                    width: { xs: "calc(100vw - 24px)", sm: isRoutesReportExpanded ? "min(94vw, 1100px)" : "min(86vw, 680px)" },
                    maxHeight: "min(92dvh, 960px)", overflow: "hidden", border: "none", borderRadius: 4,
                    backgroundColor: "#fff", boxShadow: "0 24px 70px rgba(0, 0, 0, 0.28)", transition: "width 200ms ease",
                    "& .report-filter-body .MuiFormControl-root": { width: "100%" },
                    "& .report-filter-body .MuiAutocomplete-root": { width: "100%" },
                    "& .report-filter-body .MuiOutlinedInput-root": {
                        minHeight: 56, borderRadius: 2, backgroundColor: "#fff",
                        transition: "box-shadow 200ms ease, border-color 200ms ease",
                        "& fieldset": { borderColor: "rgba(0, 63, 74, 0.24)" },
                        "&:hover fieldset": { borderColor: "#006C77" },
                        "&.Mui-focused": { boxShadow: "0 0 0 3px rgba(0, 183, 0, 0.12)" },
                        "&.Mui-focused fieldset": { borderColor: "#00B700" },
                        "&.Mui-disabled": { backgroundColor: "rgba(0, 63, 74, 0.04)" },
                    },
                    "& .report-filter-body .MuiInputLabel-root": { fontFamily: "Prometo" },
                }}>
                    <RoutesReportTab customers={getCurrentUser.configs.isManager ? customersList : undefined} initialCustomerId={customer.id > 0 ? customer.id : undefined} onClose={() => setIsOpenRoutesReport(false)} onExpandedChange={setIsRoutesReportExpanded} />
                </Paper>
            </Rmodal>}
            <Box
                className="grid-box-out-container tw-flex tw-h-screen tw-w-full tw-items-center tw-justify-center"
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100vh",
                    background: "transparent",
                }}
            >
                <Box
                    className="grid-container container container-fluid tw-relative tw-overflow-hidden tw-rounded-lg tw-border-0 tw-bg-white tw-shadow-md tw-transition-all tw-duration-300 tw-ease-gtr-smooth"
                    style={{
                        marginTop: "2%",
                        background: "#ffff",
                        transition: "all 0.3s ease-out allow-discrete",
                        borderRadius: 8,
                        position: "relative",
                    }}
                >
                    <Toolbar
                        className="grid-header-bar tw-m-2.5 tw-rounded-lg tw-bg-gtr-sidebar tw-text-white"
                        sx={{
                            display: "flex",
                            minHeight: { xs: "auto", md: 64 },
                            backgroundColor: "#09414A",
                            fontFamily: "Prometo",
                            margin: "10px",
                            padding: { xs: 1.25, md: "4px 12px" },
                            borderRadius: 2,
                            color: "#ffff",
                            position: "relative",
                        }}
                    >
                        <Box
                            className="header-actions tw-grid tw-w-full tw-items-center tw-gap-3 md:tw-grid-cols-[minmax(170px,5fr)_minmax(280px,6fr)_auto]"
                            sx={{
                                display: "grid",
                                gridTemplateColumns: { xs: "1fr auto", md: "minmax(170px, 5fr) minmax(280px, 6fr) auto" },
                                alignItems: "center",
                                gap: 1.5,
                                fontFamily: "Prometo",
                                width: "100%",
                            }}
                        >
                            <Box
                                className="header-box-title tw-flex tw-min-w-0 tw-items-center"
                                sx={{ minWidth: 0, paddingLeft: 1, transition: "all 0.2s ease-out allow-discrete" }}
                            >
                                <Typography sx={{ fontFamily: "Prometo", fontSize: 18, fontWeight: 700 }}>Relatórios</Typography>
                            </Box>

                            <Box
                                className="list-options tw-min-w-0"
                                sx={{ gridColumn: { xs: "1 / -1", md: "auto" }, gridRow: { xs: 2, md: "auto" }, padding: 0, transition: "all 0.2s ease-out allow-discrete" }}
                            >
                                <FormControl className="form-group" style={{ display: "flex", width: "100%" }}>
                                    <TextField
                                        name="name"
                                        type="text"
                                        autoComplete="off"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchOutlined sx={{ color: "rgba(255,255,255,0.72)" }} />
                                                </InputAdornment>
                                            ),
                                            endAdornment: query ? (
                                                <InputAdornment position="end">
                                                    <Tooltip title="Limpar pesquisa" arrow placement="top">
                                                        <IconButton
                                                            size="small"
                                                            aria-label="Limpar pesquisa de relatórios"
                                                            onClick={() => setQuery("")}
                                                            sx={{ color: "rgba(255,255,255,0.72)" }}
                                                        >
                                                            <ClearOutlined fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </InputAdornment>
                                            ) : null,
                                            style: {
                                                fontFamily: "Prometo",
                                                color: "#fff",
                                                backgroundColor: "rgba(255,255,255,0.15)",
                                                borderRadius: 8,
                                                paddingRight: 8,
                                            },
                                        }}
                                        placeholder="Nome ou descrição"
                                        className="group-search"
                                        value={query}
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => setQuery(event.target.value)}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                minHeight: 44,
                                                height: 44,
                                                transition: "background-color 200ms ease, box-shadow 200ms ease",
                                                "& fieldset": { border: "none" },
                                                "&:hover fieldset": { border: "none" },
                                                "&.Mui-focused fieldset": { border: "1px solid rgba(255,255,255,0.50)" },
                                                "&.Mui-focused": { boxShadow: "0 0 0 3px rgba(255,255,255,0.10)" },
                                            },
                                            "& input::placeholder": { color: "rgba(255,255,255,0.72)", opacity: 1 },
                                        }}
                                    />
                                </FormControl>
                            </Box>
                            <Tooltip title="Fechar" arrow>
                                <IconButton
                                    aria-label="Fechar relatórios"
                                    onClick={() => window.location.replace("/")}
                                    className="!tw-text-white tw-transition-colors tw-duration-200 hover:!tw-bg-white/10"
                                    sx={{
                                        gridColumn: { xs: 2, md: "auto" },
                                        gridRow: { xs: 1, md: "auto" },
                                        width: 40,
                                        height: 40,
                                        borderRadius: 2,
                                        color: "#ffff",
                                        transition: "background-color 0.2s ease-out",
                                        "&:hover": { backgroundColor: "rgba(255,255,255,0.12)" },
                                    }}
                                >
                                    <CloseOutlined />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Toolbar>

                    <Grid
                        container
                        style={{
                            marginTop: 2,
                            borderRadius: 5,
                            fontFamily: "Prometo",
                            height: 650,
                            display: "flex",
                            justifyContent: loading ? "center" : "start",
                            alignItems: loading ? "center" : "start",
                        }}
                    >
                        {loading && (
                            <div
                                style={{
                                    width: "100%",
                                    padding: 20,
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "column",
                                }}
                            >
                                <div className="tracker-loading">
                                    <div className="ld-tracker">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <Box className="report-screen tw-w-full" style={{ width: "100%" }}>
                            {!loading && getCurrentUser.configs?.isManager && !isTechnician && (
                                <Tabs
                                    value={uppertTabValue}
                                    onChange={handleUpperChangeTab}
                                    variant="standard"
                                    indicatorColor="primary"
                                    textColor="inherit"
                                    aria-label="icon tabs info"
                                    className="tab-container"
                                    sx={{
                                        minHeight: 48,
                                        fontFamily: "Prometo",
                                        backgroundColor: "#00B700",
                                        "& .MuiTab-root": {
                                            minHeight: 48,
                                            fontFamily: "Prometo",
                                            fontSize: 16,
                                            fontWeight: 600,
                                            textTransform: "none",
                                            color: "rgba(255,255,255,0.82)",
                                            transition: "color 180ms ease, opacity 180ms ease",
                                        },
                                        "& .Mui-selected": { color: "#fff !important" },
                                        "& .MuiTabs-indicator": { height: 3, borderRadius: 3, backgroundColor: "#fff" },
                                    }}
                                >
                                    <Tab label="Administrativo" value={4} />
                                    <Tab label="Cliente" value={5} />
                                </Tabs>
                            )}
                            <Divider />
                            {getCurrentUser.configs?.isManager && !isTechnician &&
                                <>
                                    <TabPanel className="report-screen-sub-panel" value={uppertTabValue} index={5}>
                                        {!loading && (
                                            <Tabs
                                                value={tabValue}
                                                onChange={handleChangeTab}
                                                variant="standard"
                                                indicatorColor="primary"
                                                textColor="inherit"
                                                aria-label="icon tabs info"
                                                className="tab-container"
                                                sx={{
                                                    minHeight: 48,
                                                    fontFamily: "Prometo",
                                                    backgroundColor: "#f3f4f6",
                                                    "& .MuiTab-root": {
                                                        minHeight: 48,
                                                        color: "#52666a",
                                                        fontFamily: "Prometo",
                                                        fontSize: 15,
                                                        fontWeight: 600,
                                                        textTransform: "none",
                                                        transition: "color 180ms ease, opacity 180ms ease",
                                                    },
                                                    "& .Mui-selected": { color: "#00B700 !important" },
                                                    "& .MuiTabs-indicator": { height: 3, borderRadius: 3, backgroundColor: "#00B700" },
                                                }}
                                            >
                                                <Tab label="Operacionais/Monitoramento" value={0} />
                                                <Tab label="Analíticos" value={1} />
                                                <Tab label="Quantitativos" value={2} />
                                                <Tab label="Mapa" value={3} />
                                            </Tabs>
                                        )}
                                    </TabPanel>
                                </>}
                            {!loading && !getCurrentUser.configs?.isManager && (
                                <Tabs
                                    value={tabValue}
                                    onChange={handleChangeTab}
                                    variant="standard"
                                    indicatorColor="primary"
                                    textColor="inherit"
                                    aria-label="icon tabs info"
                                    className="tab-container"
                                    sx={{
                                        minHeight: 48,
                                        fontFamily: "Prometo",
                                        backgroundColor: "#00B700",
                                        "& .MuiTab-root": {
                                            minHeight: 48,
                                            fontFamily: "Prometo",
                                            fontSize: 15,
                                            fontWeight: 600,
                                            textTransform: "none",
                                            color: "rgba(255,255,255,0.82)",
                                            transition: "color 180ms ease, opacity 180ms ease",
                                        },
                                        "& .Mui-selected": { color: "#fff !important" },
                                        "& .MuiTabs-indicator": { height: 3, borderRadius: 3, backgroundColor: "#fff" },
                                    }}
                                >
                                    <Tab label="Operacionais/Monitoramento" value={0} />
                                    {getCurrentUser.accessProfile.id !== Number(PROFILE_ACESSES.DRIVER) && <Tab label="Analíticos" value={1} />}
                                    {getCurrentUser.accessProfile.id !== Number(PROFILE_ACESSES.DRIVER) && <Tab label="Quantitativos" value={2} />}
                                    {getCurrentUser.accessProfile.id !== Number(PROFILE_ACESSES.DRIVER) && <Tab label="Mapa" value={3} />}
                                </Tabs>
                            )}
                            <Divider />
                            <Box
                                className="tw-grid tw-grid-cols-1 tw-gap-2.5 tw-p-2.5 md:tw-grid-cols-2"
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" },
                                    alignContent: "start",
                                    gap: 1.25,
                                    padding: 1.25,
                                }}
                            >
                                {dataPage.currentData().length === 0 ? (
                                    <Box
                                        className="tw-col-span-full tw-grid tw-place-items-center"
                                        sx={{ gridColumn: "1 / -1", display: "grid", justifyContent: "center", alignItems: "center" }}
                                    >
                                        {!loading && (
                                            <>
                                                <CardMedia
                                                    className="grid-empty-image dark:!tw-hidden"
                                                    sx={{ height: 280, width: { xs: 280, sm: 350 }, maxWidth: "100%", objectFit: "cover", border: "none" }}
                                                    image={require("../../../assets/files/nocontent.png")}
                                                    aria-hidden="true"
                                                />
                                                <Typography className="grid-empty-message" sx={{ fontSize: 18, fontFamily: "Prometo", color: "#00B700" }}>
                                                    Nenhum dado encontrado.
                                                </Typography>
                                            </>
                                        )}
                                    </Box>
                                ) : (
                                    !loading && dataPage.currentData().map((item) => {
                                        const openSelectedReport = () => {
                                            if (item.id === 5 && reportType === "map") {
                                                setIsRoutesReportExpanded(false);
                                                setIsOpenRoutesReport(true);
                                            } else if (item.name.includes("Melhor rota")) {
                                                setIsOpenReportMap(true);
                                                setSelectedReport(item);
                                            } else {
                                                setIsOpenDetails(true);
                                                setSelectedReport(item);
                                            }
                                        };

                                        return (
                                            <Card
                                                key={item.id}
                                                role="button"
                                                tabIndex={0}
                                                aria-label={`Configurar relatório ${item.name}`}
                                                onClick={openSelectedReport}
                                                onKeyDown={(event) => {
                                                    if (event.key === "Enter" || event.key === " ") {
                                                        event.preventDefault();
                                                        openSelectedReport();
                                                    }
                                                }}
                                                className="report-option-card tw-group tw-w-full tw-cursor-pointer tw-overflow-hidden tw-rounded-xl tw-border-0 tw-bg-slate-100 tw-shadow-none tw-transition-all tw-duration-200 hover:-tw-translate-y-0.5 hover:tw-bg-slate-50 hover:tw-shadow-md"
                                                sx={{
                                                    width: "100%",
                                                    minWidth: 0,
                                                    color: "black",
                                                    backgroundColor: "#f3f4f6",
                                                    border: "none",
                                                    borderRadius: 3,
                                                    boxShadow: "none",
                                                    transition: "transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease",
                                                    "&:hover": {
                                                        backgroundColor: "#f8fafc",
                                                        transform: "translateY(-2px)",
                                                        boxShadow: "0 8px 20px rgba(9,65,74,0.10)",
                                                    },
                                                    "&:focus-visible": { outline: "2px solid #00B700", outlineOffset: 2 },
                                                }}
                                            >
                                                <CardActions sx={{ width: "100%", minHeight: 64, padding: 1.25 }}>
                                                    <Box className="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-3">
                                                        <Box
                                                            className="tw-flex tw-h-10 tw-w-10 tw-flex-none tw-items-center tw-justify-center tw-rounded-xl tw-bg-gtr-teal/10 tw-text-gtr-teal"
                                                            sx={{ width: 40, height: 40, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 2.5, color: "#006C77", backgroundColor: "rgba(0,108,119,0.09)" }}
                                                        >
                                                            {item.icon}
                                                        </Box>
                                                        <Box sx={{ minWidth: 0, flex: 1 }}>
                                                            <Typography className="report-option-title" noWrap sx={{ fontFamily: "Prometo", fontSize: 14, fontWeight: 700, color: "#263238" }}>
                                                                {item.name}
                                                            </Typography>
                                                            <Typography className="report-option-description" noWrap sx={{ fontFamily: "Prometo", fontSize: 11.5, color: "#607d80", mt: 0.25 }}>
                                                                {item.description}
                                                            </Typography>
                                                        </Box>
                                                    </Box>

                                                    <Tooltip title="Configurações" arrow placement="left">
                                                        <IconButton
                                                            aria-label={`Configurar ${item.name}`}
                                                            className="refresh-button-icon !tw-bg-gtr-green !tw-text-white tw-transition-all tw-duration-200 hover:!tw-bg-gtr-green hover:tw-shadow-md"
                                                            onClick={(event) => {
                                                                event.stopPropagation();
                                                                openSelectedReport();
                                                            }}
                                                            sx={{
                                                                ml: 1,
                                                                flexShrink: 0,
                                                                backgroundColor: "#00B700",
                                                                color: "#ffff",
                                                                width: 36,
                                                                height: 36,
                                                                transition: "transform 180ms ease, box-shadow 180ms ease",
                                                                "&:hover": { backgroundColor: "#00B700", transform: "translateY(-1px)", boxShadow: "0 6px 14px rgba(0,183,0,0.22)" },
                                                            }}
                                                        >
                                                            <SettingsOutlined fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </CardActions>
                                            </Card>
                                        );
                                    })
                                )}
                            </Box>
                        </Box>
                    </Grid>
                    <Pagination
                        className="tw-flex tw-justify-end tw-px-2.5 tw-pb-2.5"
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            px: 1.25,
                            pb: 1.25,
                            fontFamily: "Prometo",
                            "& .MuiPaginationItem-root": {
                                fontFamily: "Prometo",
                                transition: "background-color 180ms ease, color 180ms ease, transform 180ms ease",
                            },
                            "& .MuiPaginationItem-root:hover": { backgroundColor: "rgba(0,108,119,0.08)", transform: "translateY(-1px)" },
                            "& .Mui-selected": { backgroundColor: "#00B700 !important", color: "#fff" },
                        }}
                        count={count}
                        size="large"
                        page={page}
                        shape="circular"
                        onChange={handleChange}
                        showFirstButton
                        showLastButton
                    />
                </Box>
            </Box>
            <PdfPreviewModal
                open={isPdfModalOpen}
                onClose={() => {
                    setIsPdfModalOpen(false);
                    URL.revokeObjectURL(pdfUrl);
                }}
                fileUrl={pdfUrl}
                fileName={pdfFileName}
            />
        </>
    );
};

export default ReportPage;
